<template>
  <div class="edit-area">
    <div class="container-base fullscreen" v-show="!previewDialogVisible">
      <h1>
        <router-link :to="{ name: 'formatDetail', params: { formatId: formatId } }">{{ currentFormat.title
          }}</router-link>
      </h1>
      <div class="overflow-scroll-x step" ref="step">
        <ol>
          <li v-for="(item, index) in currentFormat.cards" :ref="'steps'" :key="item.id" :index="index" :class="{
            current: (item.id == currentCardId),
            over: (index < currentCardIndex)
          }" v-ripple>
            <a href="#" @click="goCardTo(item.id); $event.preventDefault()">
              {{ item.title }}
            </a>
          </li>
        </ol>
      </div>
      <v-touch v-bind:enabled="{ swipe: true, press: false, pan: false, tap: false, rotate: false, pinch: false }"
        v-on:swipeleft="swipeNextCard" v-on:swiperight="swipePrevCard"
        v-bind:swipe-options="{ direction: 'horizontal' }">
        <div class="cards" style="max-width: 100%;" v-show="currentCardId">

          <component v-bind:is="basicInfo" ref="editBasic" :basic-data="basicData"
            :requiredBasicFields="requiredBasicFields" :current-card-id="currentCardId"></component>

          <component v-bind:is="currentFormat.components.edit" ref="editFormat" :basic-data="basicData"
            :format-id="formatId" :preview-format="$refs.previewFormat" :example-sentences="exampleSentences"
            :current-card-id="currentCardId"></component>

          <div class="edit-form-item" style="text-align:center;margin-top: 20px;" v-show="currentCardId == 'confirm'"
            v-if="$globalVar.in_app_payments">
            <h3 v-if="$globalVar.in_app_payments" id="fontbuyarea">作成した書類のフォントを変更 </h3>
            <div class="item-body">
              <el-select v-model="formatData.selFont" @change="fontPaymentDialog" :style="formatData.selFontStyle"
                placeholder="選択してください">
                <el-option v-for="item in fontOptions" :key="item.value" :label="item.label" :style="item.value"
                  :value="item.value"></el-option>
              </el-select>
              <!-- <el-button id="send-adtop-pdf" type="success"
              style="background-color:#0F9934;border-color:#0F9934;" @click="selectFont">選択したフォントに変更</el-button> -->
              <!-- <el-button id="send-adtop-pdf" type="success"
              v-if="$firebase.isAuthenticated && ($site.appFlag != 'b' || true) && (!fontPaymented && !$globalVar.isYagiPrime) && $globalVar.in_app_payments"
              style="background-color:#0F9934;border-color:#0F9934;"
              @click="$eventHub.$emit('open-yagiprimefontpayment-dialog', formatId);">フォント変更を利用する</el-button> -->
            </div>
            <a href="/fontservicehelp" target="_blank"
              style="border-bottom: 1px solid #00342b;font-weight: bold;display: inline-block;margin-top: 10px;margin-bottom: 5px;">＞フォントサービスの説明を見る</a>
          </div>
          <div id="preview-viewer" v-show="currentCardId == 'confirm'" class="preview-viewer tab-content"
            :style="previewViewerCss" ref="previewViewer">
            <component v-bind:is="currentFormat.components.preview" ref="previewConfirmFormat" :id-prefix="''"
              :format-data="formatData" :format-id="formatId" :basic-data="basicData" :preview-scale="previewScale"
              :current-card-id="currentCardId"></component>
          </div>
          <div class="edit-form-item" style="text-align:center;border-top: solid 1px #f8f8f8; padding: 20px 0;"
            v-show="currentCardId == 'confirm'" v-if="$globalVar.in_app_payments">
            <div class="item-body">
              <a href="#fontbuyarea" v-if="$firebase.isAuthenticated && getMode != 'production1' && !fontPaymented">
                <img src="/static/renew_img/bnr/fontbnr20230518_002.png" class="fontbuybnr" />
              </a>
            </div>
          </div>
          <div class="card-pager-nav">
            <div class="pager">
              <el-button v-ripple @click="goNextCard" :disabled="!isNextCardAvailable" type="primary">
                次へ <i class="el-icon-d-arrow-right"></i>
              </el-button>

              <el-button v-ripple icon="el-icon-d-arrow-left" @click="goPrevCard"
                :type="isNextCardAvailable ? 'text' : 'primary'" :disabled="!isPrevCardAvailable">
                前へ
              </el-button>
            </div>
          </div>

          <div class="text-right">
            <div class="save-time-message" v-show="saveNotifyMessage" v-if="$yagi.profile.autoSaveEnabled">
              <span>最終保存：</span> <span v-html="saveNotifyMessage"></span>
            </div>
            <div v-else>
              <el-button @click="$eventHub.$emit('open-account-dialog')" type="text">ブラウザに自動保存: オフ</el-button>
            </div>
          </div>

          <div class="personaldata-note">
            <p class="personaldata-note__txt">①「要配慮個人情報」（人種、信条、社会的身分、病歴、犯罪の経歴、犯罪により害を被った事実等）は記載しないでください。</p>
            <p class="personaldata-note__txt">②「要配慮個人情報」の記載を発見した場合は、該当部分について当社が責任をもって破棄いたします。</p>
          </div>

          <div class="card-preview-button" v-if="false && (formatId == 'rirekisho_job_new' ||
            formatId == 'rirekisho_job_new_single' ||
            formatId == 'internship' ||
            formatId == 'rerekisho_part_time')">
            <a href="https://www.yagish.jp/service/daigakuyagish/" target="_blank"
              style="background-color:#fff;border-color:#fff;color:#FFF"><img
                src="/static/renew2_img/bnr/univ_bnr_20230621.png" style="width:50%"></a>
          </div>
          <div class="card-preview-button" v-if="formatId == 'rirekisho_job_new#closed'">
            <el-button v-ripple plain @click="openIntroduction" type="success"
              style="background-color:#fff;border-color:#fff;color:#FFF" id="preview-button-format-edit"><img
                src="/static/renew_img/bnr/intro_bnr_20220926.png" style="width:50%"></el-button><br><br>
          </div>
          <div class="card-preview-button">
            <el-button v-ripple v-if="!$firebase.isAuthenticated && false" plain @click="showTempdata" type="success"
              style="background-color:#e3165c;border-color:#e3165c;color:#FFF" id="preview-button-format-edit"><i
                class="el-icon-upload"></i>自動バックアップ</el-button>
            <el-button v-ripple plain @click="showPreview" type="success" id="preview-button-format-edit"><i
                class="el-icon-view"></i> プレビュー</el-button>
          </div>
          <div class="bnr_list_block" v-if="$globalVar.in_app_payments">
            <ul class="renew2_flex bnr_list" v-if="false">
              <li class="bnr_item">
                <a href="/yagiprime_superagent" class="bnr_link" id="yagiprime_superagent_bnr" v-if="randomNumber == 0">
                  <img src="/static/renew3_img/yagiprime_superegent20241114.png" alt="AI面接練習バナー" class="bnr_link_img">
                </a>
                <a href="/ai/interview_practice" class="bnr_link" id="yagiprime_ai_interview_bnr" v-else>
                  <img src="/static/renew3_img/yagiprime_aiinterview20241114.png" alt="AI面接練習バナー" class="bnr_link_img">
                </a>
              </li>
            </ul>
          </div>
        </div>
      </v-touch>
    </div>

    <div class="preview-dialog" :style="previewDialogStyleObject" ref="previewDialog">
      <div class="preview-action">
        <div class="container-base">
          <ul>
            <li id="close-preview-button-above">
              <el-button class="button-block" @click="closePreview" type="success" id="buckt-to-edit-button-format-edit"
                v-ripple><i class="el-icon-d-arrow-left"></i> 入力画面に戻る</el-button>
            </li>
          </ul>
        </div>
      </div>
      <div class="blog-widghet">
        <div class="blog-widghet-inner success">
          <ul class="blog-widghet-list">
            <li>
              <a class="blog-entry-link">
                <div class="left"></div>
                <div class="right">
                  <div class="title">【注意！】印刷・ダウンロード前に、レイアウト崩れがないかご確認ください。</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="preview-tabs">

        <div class="edit-form-item" v-if="$globalVar.in_app_payments">
          <h3>作成した書類のフォントを変更 </h3>
          <div class="item-body mb-10px">
            <el-select v-model="formatData.selFont" @change="fontPaymentDialog" :style="formatData.selFontStyle"
              placeholder="選択してください">
              <el-option v-for="item in fontOptions" :key="item.value" :label="item.label" :style="item.value"
                :value="item.value"></el-option>
            </el-select>
            <!-- <el-button id="send-adtop-pdf" type="success"
              style="background-color:#0F9934;border-color:#0F9934;" @click="selectFont">選択したフォントに変更</el-button> -->
            <!-- <el-button id="send-adtop-pdf" type="success"
              v-if="$firebase.isAuthenticated && ($site.appFlag != 'b' || true) && (!fontPaymented && !$globalVar.isYagiPrime) && $globalVar.in_app_payments"
              style="background-color:#0F9934;border-color:#0F9934;"
              @click="$eventHub.$emit('open-yagiprimefontpayment-dialog', formatId);">フォント変更を利用する</el-button> -->
          </div>
          <!-- <a v-if="($globalVar.in_app_payments) && !fontPaymented" href="/fontservicehelp" target="_blank"
            style="border-bottom: 1px solid #00342b;font-weight: bold;display: inline-block;margin-top: 10px;margin-bottom: 5px;">＞フォントサービスの説明を見る</a>
          <p v-if="($globalVar.in_app_payments) && !fontPaymented" style="color: red; font-size: 0.6rem;">
            ※フォント選択は有料となりました。<br>引き続き履歴書作成は無料でお使いいただけます。</p> -->
        </div>
        <input id="user-viewer-tab" type="radio" name="preview-tab-active" v-model="previewTabActive"
          value="previewFormat">
        <label class="tab-item" for="user-viewer-tab">プレビュー</label>

        <input id="example-viewer-tab" type="radio" name="preview-tab-active" v-model="previewTabActive"
          value="sampleFormat">
        <label class="tab-item" for="example-viewer-tab">記入例</label>

        <div id="preview-viewer" v-show="previewTabActive == 'previewFormat'" class="preview-viewer tab-content"
          :style="previewViewerCss" ref="previewViewer">
          <component v-bind:is="currentFormat.components.preview" ref="previewFormat" :id-prefix="''"
            :format-data="formatData" :format-id="formatId" :basic-data="basicData" :preview-scale="previewScale"
            :current-card-id="currentCardId"></component>
        </div>

        <div v-if="sampleData && previewTabActive == 'sampleFormat'" id="sample-viewer"
          class="sample-viewer tab-content" :style="previewViewerCss" ref="sampleViewer">
          <component v-bind:is="currentFormat.components.preview" ref="sampleFormat" :id-prefix="'sample-'"
            :is-sample="true" :format-id="formatId" :format-data="sampleData.formatData"
            :basic-data="sampleData.basicData" :preview-scale="previewScale" :current-card-id="null"></component>
        </div>
      </div>

      <div class="preview-action">
        <div class="container-base">
          <ul>
            <li v-if="$firebase.isAuthenticated">
              <el-button id="pdf-download-preview" class="button-block" type="primary" v-ripple
                @click="$eventHub.$emit('download-tap');"><i class="el-icon-download"></i>
                メール送信やPDFダウンロードはこちら</el-button>
            </li>
            <li v-if="$firebase.isAuthenticated">
              <el-button id="pdf-eprint-preview" class="button-block" type="success" :disabled="!$deviceLib.isOnline"
                v-ripple
                @click="$eventHub.$emit('open-eprint-dialog', formatId, $refs.previewFormat, formatData.selFontStyle4DB)"><i
                  class="el-icon-printer"></i> コンビニで印刷する</el-button>
            </li>
            <li>
              <el-button class="button-block" @click="closePreview" type="success" v-ripple><i
                  class="el-icon-d-arrow-left"></i> 入力画面に戻る</el-button>
            </li>
          </ul>
        </div>
      </div>

    </div>
    <div class="container-base" v-if="!preview">
      <div class="footer-yagi">
        <your-yagi :your-yagi-class="{}"
          :yagi-options="{ dialogEnabled: true, rubyEnabled: true, messageEnabled: true }"></your-yagi>
      </div>
    </div>

    <div v-if="isDevelopment">
      <input type="button" @click="devAreaVisible = !devAreaVisible" value="debug">
      <div v-if="devAreaVisible" style="background:#fff;padding:20px;">
        <el-button @click="downloadPDFWithForm">downloadPDFWithForm</el-button>
        <el-button @click="downloadPDF">downloadPDF</el-button>
        <el-button @click="setPreviewHtml">サーバー側HTML</el-button>

        <el-button @click="openSCREENSHOT">Open SCREENSHOT</el-button>
        <el-button @click="mailPDF" :disabled="this.mailPDFSending">PDFをメールで送信</el-button>
        <el-button @click="loadPdfBlob">PDFプレビュー</el-button>
        <iframe v-if="pdfBlob" :src="pdfBlob" width="400px" height="600px"></iframe>
        <object v-if="pdfBlob" :data="pdfBlob" type="application/pdf" width="400px" height="600px"></object>
        <pre>{{ dumpData() }}</pre>
      </div>
    </div>

    <eprint-dialog />
    <adtop-dialog />
    <cocorowa-dialog />
    <newgrade-dialog />
    <tempdata-dialog />
    <sendmail-dialog />
    <medley-dialog />
    <jigen-dialog />
    <tryt-dialog />
    <systemshared-dialog />
    <mynavi-ms-dialog />
    <jaic-dialog />
    <roxx-dialog />
    <athlete-dialog />
    <baton-dialog />
    <parttime-dialog />
    <yagishcareer-dialog />
    <realive-dialog />
    <jobs919-dialog />
    <all-preview-dialog />
    <miraiyu-dialog />
    <etc-dialog />
    <kirara-dialog />
    <simple-dialog />
    <neocareer-dialog />
    <yagish-dialog />
    <careerdraft-dialog />
    <reastage-dialog />
    <mynavi-dialog />
    <recruit_mc-dialog />
    <asiro-dialog />
    <capla-dialog />
    <bridge-dialog />
    <dely-dialog />
    <cellpromote-dialog />
    <loginess-dialog />
    <agrinavi-dialog />
    <recree-dialog />
    <growtrail-dialog />
    <rozas-dialog />
    <hrcareer-dialog />
    <tunaguba-dialog />
    <workport-dialog />
    <krasys-dialog />
    <xmile-dialog />
    <pleiades-dialog />
    <peacekaigo-dialog />
    <hitotech-dialog />
    <techouse-dialog />
    <pharmacareer-dialog />
    <hoikushikyujin-dialog />
    <problemsolving-dialog />
    <usenworking-dialog />
    <sms-dialog />
    <hitotechneocareer-dialog />
    <persolinnovation-dialog />
    <realtimetransfercommon-dialog />
    <login-dialog />
    <yagiprime-payment-dialog />

  </div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<style lang="scss" scoped>
.fontbuybnr {
  width: 50%;
}

@media screen and (max-width: 480px) {
  .fontbuybnr {
    width: 100%;
  }
}

.personaldata-note {
  margin: 10px 0;

  &__txt {
    font-size: 12px;
    opacity: 0.6;
  }
}
</style>
<script>
import basicInfo from '@/components/BasicInfo'
import timeAgo from '@/assets/lib/time-ago-jp'
import _ from '@/assets/lib/my-lodash'

import EprintDialog from '@/components/EprintDialog'
import AdtopDialog from '@/components/AdtopDialog'
import SendMailDialog from '@/components/SendMailDialog'
import CocorowaDialog from '@/components/CocorowaDialog'
import NewGradeDialog from '@/components/NewGradeDialog'
import TempDataDialog from '@/components/TempDataDialog'
import MedleyDialog from '@/components/MedleyDialog'
import JigenDialog from '@/components/JigenDialog'
import TrytDialog from '@/components/TrytDialog'
import MynaviMsDialog from '@/components/MynaviMsDialog'
import SystemSharedDialog from '@/components/SystemSharedDialog'
import JaicDialog from '@/components/JaicDialog'
import RoxxDialog from '@/components/RoxxDialog'
import BatonDialog from '@/components/BatonDialog'
import YagishCareerDialog from '@/components/YagishCareerDialog'
import AthleteDialog from '@/components/AthleteDialog'
import ParttimeDialog from '@/components/ParttimeDialog'
import Job919Dialog from '@/components/Job919Dialog'
import RealiveDialog from '@/components/RealiveDialog'
import AllPreviewDialog from '@/components/AllPreviewDialog'
import MiraiyuDialog from '@/components/MiraiyuDialog'
import EtcDialog from '@/components/EtcDialog'
import JoblistDialog from '@/components/JobListDialog'
import KiraraDialog from '@/components/KiraraDialog'
import SimpleDialog from '@/components/SimpleDialog'
import NeocareerDialog from '@/components/NeocareerDialog'
import YagishDialog from '@/components/YagishDialog'
import CareerdraftDialog from '@/components/CareerdraftDialog'
import ReastageDialog from '@/components/ReastageDialog'
import MynaviDialog from '@/components/MynaviDialog'
import RecruitMcDialog from '@/components/RecruitMcDialog'
import AsiroDialog from '@/components/AsiroDialog'
import CaplaDialog from '@/components/CaplaDialog'
import BridgeDialog from '@/components/BridgeDialog'
import DelyDialog from '@/components/DelyDialog'
import CellpromoteDialog from '@/components/CellpromoteDialog'
import LoginessDialog from '@/components/LoginessDialog'
import AgrinaviDialog from '@/components/AgrinaviDialog'
import RecreeDialog from '@/components/RecreeDialog'
import GrowtrailDialog from '@/components/GrowtrailDialog'
import RozasDialog from '@/components/RozasDialog'
import HrcareerDialog from '@/components/HrcareerDialog'
import TunagubaDialog from '@/components/TunagubaDialog'
import WorkportDialog from '@/components/WorkportDialog'
import KrasysDialog from '@/components/KrasysDialog'
import XMileDialog from '@/components/XMileDialog'
import PleiadesDialog from '@/components/PleiadesDialog'
import PeacekaigoDialog from '@/components/PeacekaigoDialog'
import HitotechDialog from '@/components/HitotechDialog'
import TechouseDialog from '@/components/TechouseDialog'
import PharmacareerDialog from '@/components/PharmacareerDialog'
import HoikushikyujinDialog from '@/components/HoikushikyujinDialog'
import ProblemsolvingDialog from '@/components/ProblemsolvingDialog'
import UsenworkingDialog from '@/components/UsenworkingDialog'
import SmsDialog from '@/components/SmsDialog'
import HitotechneocareerDialog from '@/components/HitotechneocareerDialog'
import PersolinnovationDialog from '@/components/PersolinnovationDialog'
import RealtimeTransferCommonDialog from '@/components/RealtimeTransferCommonDialog'
import LoginDialog from '../components/LoginDialog'
import YagiprimePaymentDialog from '../components/yagiprime/YagiprimePaymentDialog'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'
// 書式1枚の高さ
const DOC_PAPER_WIDTH_PX = 794

const BACKUP_KEYS_LIST = [
  'format_rirekisho',
  'format_shokumukeirekisho',
  'format_letter',
  'format_etc',
  'format_taishokutodoke',
  'basicData',
  'recentEdit'
]

export default {
  name: 'FormatEdit',
  props: {
    formatId: {
      type: String
    },
    preview: {
      type: Boolean,
      default: false
    },
    cardId: {
      type: String
    }
  },
  components: {
    'all-preview-dialog': AllPreviewDialog,
    'eprint-dialog': EprintDialog,
    'adtop-dialog': AdtopDialog,
    'cocorowa-dialog': CocorowaDialog,
    'newgrade-dialog': NewGradeDialog,
    'tempdata-dialog': TempDataDialog,
    'sendmail-dialog': SendMailDialog,
    'medley-dialog': MedleyDialog,
    'jigen-dialog': JigenDialog,
    'roxx-dialog': RoxxDialog,
    'tryt-dialog': TrytDialog,
    'mynavi-ms-dialog': MynaviMsDialog,
    'systemshared-dialog': SystemSharedDialog,
    'jaic-dialog': JaicDialog,
    'baton-dialog': BatonDialog,
    'parttime-dialog': ParttimeDialog,
    'jobs919-dialog': Job919Dialog,
    'yagishcareer-dialog': YagishCareerDialog,
    'athlete-dialog': AthleteDialog,
    'realive-dialog': RealiveDialog,
    'miraiyu-dialog': MiraiyuDialog,
    'etc-dialog': EtcDialog,
    'joblist-dialog': JoblistDialog,
    'kirara-dialog': KiraraDialog,
    'simple-dialog': SimpleDialog,
    'neocareer-dialog': NeocareerDialog,
    'yagish-dialog': YagishDialog,
    'careerdraft-dialog': CareerdraftDialog,
    'reastage-dialog': ReastageDialog,
    'mynavi-dialog': MynaviDialog,
    'recruit_mc-dialog': RecruitMcDialog,
    'asiro-dialog': AsiroDialog,
    'capla-dialog': CaplaDialog,
    'bridge-dialog': BridgeDialog,
    'dely-dialog': DelyDialog,
    'cellpromote-dialog': CellpromoteDialog,
    'loginess-dialog': LoginessDialog,
    'agrinavi-dialog': AgrinaviDialog,
    'recree-dialog': RecreeDialog,
    'growtrail-dialog': GrowtrailDialog,
    'rozas-dialog': RozasDialog,
    'hrcareer-dialog': HrcareerDialog,
    'tunaguba-dialog': TunagubaDialog,
    'workport-dialog': WorkportDialog,
    'krasys-dialog': KrasysDialog,
    'xmile-dialog': XMileDialog,
    'pleiades-dialog': PleiadesDialog,
    'peacekaigo-dialog': PeacekaigoDialog,
    'hitotech-dialog': HitotechDialog,
    'techouse-dialog': TechouseDialog,
    'pharmacareer-dialog': PharmacareerDialog,
    'hoikushikyujin-dialog': HoikushikyujinDialog,
    'problemsolving-dialog': ProblemsolvingDialog,
    'usenworking-dialog': UsenworkingDialog,
    'sms-dialog': SmsDialog,
    'hitotechneocareer-dialog': HitotechneocareerDialog,
    'persolinnovation-dialog': PersolinnovationDialog,
    'realtimetransfercommon-dialog': RealtimeTransferCommonDialog,
    LoginDialog,
    YagiprimePaymentDialog

  },
  data: function () {
    return {
      getDisableRtConditionLimitDateTime: null,
      formatData: {},
      otherFormatData: {},
      formatInfo: {},
      basicData: {},
      basicInfo: basicInfo,
      requiredBasicFields: [],
      currentCardId: '',
      fontPaymented: false,
      previewHtml: '',
      previewDialogVisible: true,
      previewScale: 1,
      previewViewerCss: {},
      previewTabActive: 'previewFormat',
      mailPDFSending: false,
      saveNotifyMessage: '',
      saveNotifyMessageUpdateTimer: null,
      saveDate: null,
      devAreaVisible: false,
      disableRtCondition: '',
      currentFormat: {},
      downloadPdfEnabled: true,
      randomNumber: 0,
      joblistKeyword2030719: ['建設', 'ゲーム', 'エンジニア', '制作', 'コンサルタント', 'デザイナー', '清掃', '営業', '建築', '事務', '受付', '企画', 'マーケティング', '財務', '会計', '総務', '人事', '法務', '広報', '販売', '物流', '運転士', '金融', '整体師', '農業', '消防士', '警察官', '公務員', '役所', 'NPO', 'ドライバー'],
      joblistKeyword20231108: ['経理', 'フォークリフト', 'ホテル', 'ブライダル', '旅行', '事務', '管理', 'データ入力', '食品', '工場', '軽作業', '倉庫作業', 'IT', '不動産', 'サポート', '美容', '理容', 'エステ', '学校法人', '販売', '接客', 'サービス', 'クリニック', '農業', '農林水産', '製造', '開発', 'デザイナー', 'UX', 'UI', '会計', '役所', '翻訳', '通訳', '編集', '法律事務所', '物流', '受付', '営業', 'コールセンター', 'WEB', 'インターネット', '人事', '化粧品', 'マーケティング', 'ゲーム', '総務', 'エンジニア', 'SE', 'PM', 'マネージャー', 'マネジメント', '建築', '土木', '映像', '建設', '工事', 'アパレル', 'インテリア', '企画', '海運', 'コスメ', '制作', '運営', '設計', 'NPO', '法務', '校正', '金融', '広告', '印刷', '芸能', '映画', '公務員', '公共施設', 'イベント', 'レジャー', 'スポーツ', '整体師', 'コンサルタント', '電気主任技術者', '清掃', '職人', '商社', '財務', '広報', '運転士', 'ものづくり', '消防士', '警察官', '生産管理', '飲食', 'フード', '警備', '点検', '配送', '交通', 'ドライバー', '機械', '医薬', '素材', '化学', 'クリエイティブ', '士業', '医師', 'コメディカル', '保育', '教員', '講師', '介護', '福祉', '動物', '看護'],
      joblistKeyword20231113: ['ゲーム', '軽作業', 'インターネット', 'クリエイティブ', '編集', '総務', 'IT', 'NPO', '役所', '金融', '映像', '広告', '美容', '開発', '教員', '経理', 'WEB', 'コンサルタント', '理容', 'SE', 'マーケティング', '動物', 'フォークリフト', '公務員', '旅行', '翻訳', '事務', 'ホテル', '学校法人', 'ドライバー', '化学', 'マネージャー', '未経験', '人事', '農業', '印刷', 'クリニック', '工場', '管理', '企画', '交通', '販売', '建設', '制作', '土木', '物流', '映画', '介護', '配送', '会計', '講師', 'サービス', '食品', '営業', '医薬', 'スポーツ', 'サポート', '飲食', 'インテリア', '工事', '福祉', 'エンジニア', 'デザイナー', '製造', '点検', 'エステ', 'ブライダル', '接客', 'データ入力', 'マネジメント', '50代', 'フード', '看護', '運営', 'コールセンター', '清掃', '医師', '受付', '建築', '保育', '機械', '倉庫作業', '不動産', '農林水産', 'UX', 'UI', '通訳', '法律事務所', '化粧品', 'PM', 'アパレル', '海運', 'コスメ', '設計', '法務', '校正', '芸能', '公共施設', 'イベント', 'レジャー', '整体師', '電気主任技術者', '職人', '商社', '財務', '広報', '運転士', 'ものづくり', '消防士', '警察官', '生産管理', '警備', '素材', '士業', 'コメディカル'],
      joblistKeyword20231117: ['医師', '看護', '医薬', '看護師/准看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職/ヘルパー', '管理栄養士/栄養士', '歯科助手', 'クリニック', 'ドライバー', '工場', '工事', '建設', '土木', '物流', '配送', '製造', '制作', 'SE', 'エンジニア', 'プログラミング', 'コンサルタント', 'マネージャー', 'マネジメント', 'デザイナー', 'ゲーム', '軽作業', 'インターネット', 'クリエイティブ', '編集', '総務', 'IT', 'NPO', '役所', '金融', '映像', '広告', '美容', '開発', '教員', '経理', 'WEB', '理容', 'マーケティング', '動物', 'フォークリフト', '公務員', '旅行', '翻訳', '事務', 'ホテル', '学校法人', '化学', '人事', '農業', '印刷', '管理', '企画', '交通', '販売', '映画', '介護', '会計', '講師', 'サービス', '食品', '営業', 'スポーツ', 'サポート', '飲食', 'インテリア', '福祉', '点検', 'エステ', 'ブライダル', '接客', 'データ入力', 'フード', '運営', 'コールセンター', '清掃', '受付', '建築', '保育', '機械'],
      joblistKeyword20231205: ['食品', '開発', '運営', 'スポーツ', 'サポート', '福祉', '製造', 'クリニック', '接客', '学校法人', '販売', '営業', 'サービス', '制作', 'コールセンター', '印刷', '美容', '受付', 'ホテル', '動物', '看護', '交通', '介護', 'ゲーム', 'アパレル', '事務', '講師', '飲食', 'エンジニア', '企画', '不動産', '管理', '工場', '化学', 'SE', '建設', 'IT', 'インターネット', '農業', 'webマーケティング', '広告', '土木', 'フォークリフト', '役所', '経理', 'マーケティング', '総務', '軽作業', 'マネジメント', '医薬', 'NPO', '旅行', '看護師/准看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職/ヘルパー', '管理栄養士/栄養士', '歯科助手', '工事', '物流', '配送', 'プログラミング', 'コンサルタント', 'マネージャー', 'デザイナー', 'クリエイティブ', '編集', '金融', '映像', '教員', 'WEB', '理容', '公務員', '翻訳', '人事', '映画', '会計', 'インテリア', '点検', 'エステ', 'ブライダル', 'データ入力', 'フード', '清掃', '建築', '保育', '機械'],
      joblistKeyword20231207: ['施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職', 'ヘルパー', '栄養士', '歯科助手', '販促物の製作業務', '福岡私立精華女子高等学校', '畜産農家', 'Webマーケティング', 'ペット業界', '医療法人社団三木会 花まる歯科クリニック 入社', 'CAD製図', 'アコースティックギター演奏', 'ビジネス工科専門学校', 'webライター', '高齢の母親と一緒に暮らしているため、転勤は避けたい', '高速道路', 'スポーツ国際開発', '写植', '岡山商科大学', '宿泊業', '残業', 'ダンスインストラクター', '回送', 'セールスドライバー', 'バスケ', '教育福祉', '熊本市立帯山中学校卒業', '鈑金塗装', '3Dデザイン', 'データ整理', '自動車関連の仕事', 'グランドハンドリング', '接客販売業', '接客サービス業', '電話受付', '在宅の仕事', '中古車販売', 'マーケティングリサーチ', '総務労務', '配送業務', '鍼灸', 'パン職人', '工業高校', 'ITサポート', 'ヤマト運輸', '郵便局', '化学工学', 'キッチンスタッフ', 'ファッションビジネス', '日本語学科', '自然環境専門高校入学', '給与計算', 'パソコン操作', '塾講師', '猫カフェ', '接客経験', '不動産事務', '溶接', 'ライター', '不動産営業', '通関士', 'アパレル販売', '幼児教育', '保険営業', '在宅勤務', '英語教育', '運輸', 'パソコン', '社会福祉士', '法学', '保険', '法律事務所', '電気工事士', '大学', '電気工事', 'UI', '教育', '営業事務', '製造業', '一般事務', '旅行', '医療事務', '営業職', '教員', '経済学部', '接客販売', '医療', 'マネジメント', '自動車', 'IT', '日本語教師', 'マーケティング', '経理', '医薬', 'ホテル', '調理師', '総務', 'フォークリフト', '飲食業', '建設', '軽作業', '農業', 'ゲーム', '工場', '未経験', '企画', 'インテリア', '役所', '化学', 'デザイン', '美容師', '広告', '美容', '営業', '土木', '警備', '管理', '事務', '飲食', '事務職', 'コールセンター', 'エンジニア', 'インターネット', 'SE', 'NPO', '福祉', '映像', '学校法人', '介護', '講師', '医師', '接客', '不動産', '接客業', '看護', '受付', '交通', '公務員', '動物', 'サービス', '製造', '配送', '販売', 'データ入力', 'アパレル', 'スポーツ', '印刷', '制作', '人事', 'クリニック', '開発', '保育', 'サポート', '機械', '運営', '食品', 'プラスチック成形', '土日勤務', '運動経験', 'データ検査', 'アニメ声優', '東大阪市立日新高等学校', '土木施工管理', '情報環境科', '洋服販売', 'エリアマネジャー', 'ビジネススクール', '中古ジュエリー販売', '岡山', 'お寿司の製造', '期間工', '教育関係', '接客応対', '舞台設備工事', '倉庫オペレータ', '会計税務アシスタント', '売り場づくり', '保育士補助', 'ECサイトの運営業務', '障害者移動支援', 'バル', '小学校通訳', '経理総務事務', 'アミューズメントパーク', '材料技術', '陸送業務', 'IT職種', '総合受付業務', '損保事務', 'ITインフラエンジニア', '医療技術短期大学部', '保育園看護師', '軽貨物運送事業', '漫画家', 'エアジャパン', '成田国際空港', 'アトラクションメンテナンス', 'オンライン決済代行業', '総務部', '建設用軽仮設機材', '子育て支援員', '回収車', '尾瀬高等学校', '洗車', 'フィギュア買い取り', '広島県立安西高等学校', '日立エレベーターサービス株式会社', '大型ダンプ運転手', '損害保険調査', 'プロダクトデザイナー', '熊本県立八代高等学校', 'コンタクトセンター', '物流倉庫内のクール便の仕分け作業', '鮮魚部門', '事務調達職', '千葉県立市原高等学校', '日本化粧品検定2級合格', '千葉県立成田北高等学校', '美容外科 受付 サポート 事務', '財務事務', '医療IT業界', '金属プレス', '営業経験', '土地仕入業務', '医療・保育・介護', '事務リーダー', '人材営業', 'MR', '文章構成', '子供英語講師', '筋力トレーニング', '大型自動車免許', '生産技術業務', '化学生命工学', 'スフォリアテッラ専門店', 'トラブル解決', 'ネットショップ', '事務一般', '短大', '大阪大学人間科学部人間科学科', '製造ライン', 'アプリケーション開発', '石油化学プラント オペレーター', 'Web', '医学技術', '福祉心理', '法務事務', '技術専門', '競走馬', '郵便配達', '飲食サービス', '提案営業', '茨城県立ルネサンス高等学校', '製造工場', 'インテリア業界', '弁護士', '成田空港地上職', '広島市立舟入高等学校', '大学事務員', 'リユース業', '文化財学科', '短期アルバイト', 'EC店鋪運営', '医療サービス業', '医師事務作業補助者', '製袋機オペレーター', '物流企画', '給排水処理設備の運転管理', '通信', '物流倉庫スタッフ', '第二種電気工事士', 'カバーディーラー', '国際英語学科', 'アトラクション運営', '横浜駅周辺', '送電線業界の建設土木', 'データマネージャー', '美術科', '介護施設', '総合事務', '東洋大学', '食物調理', '理学療法', '会計・税務知識', '生活支援員', '旅行業界', '生活相談員', 'パソコン作業', '土木建設業', 'ロボット工学', '施工管理アシスタント', '食品栄養学', '教育支援', '情報専門学校', '設備メンテナンス', 'PC業務', '買取営業', '介護事務', '医療従事者', 'インテリア・住宅関連', '工事現場管理', 'ネットワーク', '訪問介護', '不動産管理', '医療機関', '配達ドライバー', 'メンテナンス', '日本の仕事', '航空貨物', 'インサイドセールス', 'サッカー', 'システムエンジニア・プログラマ', '佐賀県立佐賀農業高等学校', '国際関係学', '社長秘書', '英語力', 'カラオケ', '総務職', '副業', '文学', '経営コンサルタント', '喫茶店', '総務経理事務', 'キッチン', '人材紹介', '工業化学', '病棟クラーク', '指導員', 'テクニカルスタッフ', '音楽講師', '倉庫内作業', 'デンソー', '組立', 'セレクトショップ', '障がい者支援', '警備員', '国際営業', '派遣', '美容室受付', '心理カウンセリング', '鮮魚', '文学部', '倉庫', '営業サポート', '普通自動車第一種運転免許取得', '外国語学部', 'ビジネスマネジメント', '受付兼助手', '医学部', '映像編集', '建築設備点検', '鉄道', '経営学科', '英会話講師', '営業事務職', '人事職', 'デジタルマーケティング', 'SNSマーケティング', '獣医', '自衛隊', '養護教諭', '短期バイト', 'Web開発', 'ホテル業界', '事務・秘書・受付', '看護助手', 'トラック運転手', '国際経済学', 'ルート営業', 'webデザイナー', '調剤薬局事務', '金融業務', '法政大学', '携帯電話販売', 'プログラマー', '設備管理', '仕分け', 'ゲーム業界', '臨床検査技師', 'CADオペレーター', 'WEBデザイン', '陸上自衛隊', '動物看護', '製造業務', '神社', '経理業務', '倉庫作業', '派遣社員', '地理学', '医療機器', '事務業務', '物流業', 'システムエンジニア', '建築設計', '英米文学', '製造オペレーター', '歯科技工士', '高校生', '司書', '日本文学', '歯科', '国際経営', 'ITエンジニア', 'カウンセラー', '運転', '人材コーディネーター', '機械工学', '運送業', 'ファッションデザイン', '新卒', 'インフラエンジニア', '製造職', '工場勤務', '製菓', '販売業務', '経営学部', '日本文化', '整備士', '料理', '法人営業', 'パティシエ', 'DTPオペレーター', '法務', '自動車整備士', '早稲田大学', '飲食店', '医療法人', '経理事務', '事務作業', '倉庫管理', '総務事務', 'システム開発', 'ものづくり', '受付業務', '調剤事務', '介護福祉士', 'グラフィックデザイン', '情報処理', '調理', '財務', '自動車販売', 'ドライバー', '接客業務', 'データ分析', '食品製造', '経営学', '管理栄養士', '士業', 'ゲーム開発', '品質管理', '社会福祉', '銀行', '法律', '生産管理', 'IT業界', '受付事務', '販売員', '建設業', '不動産業', '心理学', 'レジャー', '大学卒業後', 'アルバイト', 'コンサルタント', '翻訳', '物流', '通訳', '販売職', '編集', '工事', '経済学', '会計', 'デザイナー', 'プログラミング', '理容', '音楽', 'ブライダル', '建築', '映画', 'マネージャー', '点検', '設計', '化粧品', 'エステ', 'フード', '清掃', '金融', 'イベント', 'プロジェクトマネージャー', 'クリエイティブ'],
      joblistKeyword20231222: ['施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職', 'ヘルパー', '栄養士', '歯科助手', '販促物の製作業務', '福岡私立精華女子高等学校', '畜産農家', 'Webマーケティング', 'ペット業界', '医療法人社団三木会 花まる歯科クリニック 入社', 'CAD製図', 'アコースティックギター演奏', 'ビジネス工科専門学校', 'webライター', '高齢の母親と一緒に暮らしているため、転勤は避けたい', '高速道路', 'スポーツ国際開発', '写植', '岡山商科大学', '宿泊業', '残業', 'ダンスインストラクター', '回送', 'セールスドライバー', 'バスケ', '教育福祉', '熊本市立帯山中学校卒業', '鈑金塗装', '3Dデザイン', 'データ整理', '自動車関連の仕事', 'グランドハンドリング', '接客販売業', '接客サービス業', '電話受付', '在宅の仕事', '中古車販売', 'マーケティングリサーチ', '総務労務', '配送業務', '鍼灸', 'パン職人', '工業高校', 'ITサポート', 'ヤマト運輸', '郵便局', '化学工学', 'キッチンスタッフ', 'ファッションビジネス', '日本語学科', '自然環境専門高校入学', '給与計算', 'パソコン操作', '塾講師', '猫カフェ', '接客経験', '不動産事務', '溶接', 'ライター', '不動産営業', '通関士', 'アパレル販売', '幼児教育', '保険営業', '在宅勤務', '英語教育', '運輸', 'パソコン', '社会福祉士', '法学', '保険', '法律事務所', '電気工事士', '大学', '電気工事', 'UI', '教育', '営業事務', '製造業', '一般事務', '旅行', '医療事務', '営業職', '教員', '経済学部', '接客販売', '医療', 'マネジメント', '自動車', 'IT', '日本語教師', 'マーケティング', '経理', '医薬', 'ホテル', '調理師', '総務', 'フォークリフト', '飲食業', '建設', '軽作業', '農業', 'ゲーム', '工場', '未経験', '企画', 'インテリア', '役所', '化学', 'デザイン', '美容師', '広告', '美容', '営業', '土木', '警備', '管理', '事務', '飲食', '事務職', 'コールセンター', 'エンジニア', 'インターネット', 'SE', 'NPO', '福祉', '映像', '学校法人', '介護', '講師', '医師', '接客', '不動産', '接客業', '看護', '受付', '交通', '公務員', '動物', 'サービス', '製造', '配送', '販売', 'データ入力', 'アパレル', 'スポーツ', '印刷', '制作', '人事', 'クリニック', '開発', '保育', 'サポート', '機械', '運営', '食品', 'プラスチック成形', '土日勤務', '運動経験', 'データ検査', 'アニメ声優', '東大阪市立日新高等学校', '土木施工管理', '情報環境科', '洋服販売', 'エリアマネジャー', 'ビジネススクール', '中古ジュエリー販売', '岡山', 'お寿司の製造', '期間工', '教育関係', '接客応対', '舞台設備工事', '倉庫オペレータ', '会計税務アシスタント', '売り場づくり', '保育士補助', 'ECサイトの運営業務', '障害者移動支援', 'バル', '小学校通訳', '経理総務事務', 'アミューズメントパーク', '材料技術', '陸送業務', 'IT職種', '総合受付業務', '損保事務', 'ITインフラエンジニア', '医療技術短期大学部', '保育園看護師', '軽貨物運送事業', '漫画家', 'エアジャパン', '成田国際空港', 'アトラクションメンテナンス', 'オンライン決済代行業', '総務部', '建設用軽仮設機材', '子育て支援員', '回収車', '尾瀬高等学校', '洗車', 'フィギュア買い取り', '広島県立安西高等学校', '日立エレベーターサービス株式会社', '大型ダンプ運転手', '損害保険調査', 'プロダクトデザイナー', '熊本県立八代高等学校', 'コンタクトセンター', '物流倉庫内のクール便の仕分け作業', '鮮魚部門', '事務調達職', '千葉県立市原高等学校', '日本化粧品検定2級合格', '千葉県立成田北高等学校', '美容外科 受付 サポート 事務', '財務事務', '医療IT業界', '金属プレス', '営業経験', '土地仕入業務', '医療・保育・介護', '事務リーダー', '人材営業', 'MR', '文章構成', '子供英語講師', '筋力トレーニング', '大型自動車免許', '生産技術業務', '化学生命工学', 'スフォリアテッラ専門店', 'トラブル解決', 'ネットショップ', '事務一般', '短大', '大阪大学人間科学部人間科学科', '製造ライン', 'アプリケーション開発', '石油化学プラント オペレーター', 'Web', '医学技術', '福祉心理', '法務事務', '技術専門', '競走馬', '郵便配達', '飲食サービス', '提案営業', '茨城県立ルネサンス高等学校', '製造工場', 'インテリア業界', '弁護士', '成田空港地上職', '広島市立舟入高等学校', '大学事務員', 'リユース業', '文化財学科', '短期アルバイト', 'EC店鋪運営', '医療サービス業', '医師事務作業補助者', '製袋機オペレーター', '物流企画', '給排水処理設備の運転管理', '通信', '物流倉庫スタッフ', '第二種電気工事士', 'カバーディーラー', '国際英語学科', 'アトラクション運営', '横浜駅周辺', '送電線業界の建設土木', 'データマネージャー', '美術科', '介護施設', '総合事務', '東洋大学', '食物調理', '理学療法', '会計・税務知識', '生活支援員', '旅行業界', '生活相談員', 'パソコン作業', '土木建設業', 'ロボット工学', '施工管理アシスタント', '食品栄養学', '教育支援', '情報専門学校', '設備メンテナンス', 'PC業務', '買取営業', '介護事務', '医療従事者', 'インテリア・住宅関連', '工事現場管理', 'ネットワーク', '訪問介護', '不動産管理', '医療機関', '配達ドライバー', 'メンテナンス', '日本の仕事', '航空貨物', 'インサイドセールス', 'サッカー', 'システムエンジニア・プログラマ', '佐賀県立佐賀農業高等学校', '国際関係学', '社長秘書', '英語力', 'カラオケ', '総務職', '副業', '文学', '経営コンサルタント', '喫茶店', '総務経理事務', 'キッチン', '人材紹介', '工業化学', '病棟クラーク', '指導員', 'テクニカルスタッフ', '音楽講師', '倉庫内作業', 'デンソー', '組立', 'セレクトショップ', '障がい者支援', '警備員', '国際営業', '派遣', '美容室受付', '心理カウンセリング', '鮮魚', '文学部', '倉庫', '営業サポート', '普通自動車第一種運転免許取得', '外国語学部', 'ビジネスマネジメント', '受付兼助手', '医学部', '映像編集', '建築設備点検', '鉄道', '経営学科', '英会話講師', '営業事務職', '人事職', 'デジタルマーケティング', 'SNSマーケティング', '獣医', '自衛隊', '養護教諭', '短期バイト', 'Web開発', 'ホテル業界', '事務・秘書・受付', '看護助手', 'トラック運転手', '国際経済学', 'ルート営業', 'webデザイナー', '調剤薬局事務', '金融業務', '法政大学', '携帯電話販売', 'プログラマー', '設備管理', '仕分け', 'ゲーム業界', '臨床検査技師', 'CADオペレーター', 'WEBデザイン', '陸上自衛隊', '動物看護', '製造業務', '神社', '経理業務', '倉庫作業', '派遣社員', '地理学', '医療機器', '事務業務', '物流業', 'システムエンジニア', '建築設計', '英米文学', '製造オペレーター', '歯科技工士', '高校生', '司書', '日本文学', '歯科', '国際経営', 'ITエンジニア', 'カウンセラー', '運転', '人材コーディネーター', '機械工学', '運送業', 'ファッションデザイン', '新卒', 'インフラエンジニア', '製造職', '工場勤務', '製菓', '販売業務', '経営学部', '日本文化', '整備士', '料理', '法人営業', 'パティシエ', 'DTPオペレーター', '法務', '自動車整備士', '早稲田大学', '飲食店', '医療法人', '経理事務', '事務作業', '倉庫管理', '総務事務', 'システム開発', 'ものづくり', '受付業務', '調剤事務', '介護福祉士', 'グラフィックデザイン', '情報処理', '調理', '財務', '自動車販売', 'ドライバー', '接客業務', 'データ分析', '食品製造', '経営学', '管理栄養士', '士業', 'ゲーム開発', '品質管理', '社会福祉', '銀行', '法律', '生産管理', 'IT業界', '受付事務', '販売員', '建設業', '不動産業', '心理学', 'レジャー', '大学卒業後', 'アルバイト', 'コンサルタント', '翻訳', '物流', '通訳', '販売職', '編集', '工事', '経済学', '会計', 'デザイナー', 'プログラミング', '理容', '音楽', 'ブライダル', '建築', '映画', 'マネージャー', '点検', '設計', '化粧品', 'エステ', 'フード', '清掃', '金融', 'イベント', 'プロジェクトマネージャー', 'クリエイティブ'],
      joblistKeyword20240214: ['施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職', 'ヘルパー', '栄養士', '歯科助手', '郵便局', '電気工事士', '工場', '運輸', '福祉', '栄養士', 'フォークリフト', '保険', '大学', '自動車', '教育'],
      joblistKeyword: ['施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職', 'ヘルパー', '栄養士', '歯科助手', '販促物の製作業務', '福岡私立精華女子高等学校', '畜産農家', 'Webマーケティング', 'ペット業界', '医療法人社団三木会 花まる歯科クリニック 入社', 'CAD製図', 'アコースティックギター演奏', 'ビジネス工科専門学校', 'webライター', '高齢の母親と一緒に暮らしているため、転勤は避けたい', '高速道路', 'スポーツ国際開発', '写植', '岡山商科大学', '宿泊業', '残業', 'ダンスインストラクター', '回送', 'セールスドライバー', 'バスケ', '教育福祉', '熊本市立帯山中学校卒業', '鈑金塗装', '3Dデザイン', 'データ整理', '自動車関連の仕事', 'グランドハンドリング', '接客販売業', '接客サービス業', '電話受付', '在宅の仕事', '中古車販売', 'マーケティングリサーチ', '総務労務', '配送業務', '鍼灸', 'パン職人', '工業高校', 'ITサポート', 'ヤマト運輸', '郵便局', '化学工学', 'キッチンスタッフ', 'ファッションビジネス', '日本語学科', '自然環境専門高校入学', '給与計算', 'パソコン操作', '塾講師', '猫カフェ', '接客経験', '不動産事務', '溶接', 'ライター', '不動産営業', '通関士', 'アパレル販売', '幼児教育', '保険営業', '在宅勤務', '英語教育', '運輸', 'パソコン', '社会福祉士', '法学', '保険', '法律事務所', '電気工事士', '大学', '電気工事', 'UI', '教育', '営業事務', '製造業', '一般事務', '旅行', '医療事務', '営業職', '教員', '経済学部', '接客販売', '医療', 'マネジメント', '自動車', 'IT', '日本語教師', 'マーケティング', '経理', '医薬', 'ホテル', '調理師', '総務', 'フォークリフト', '飲食業', '建設', '軽作業', '農業', 'ゲーム', '工場', '未経験', '企画', 'インテリア', '役所', '化学', 'デザイン', '美容師', '広告', '美容', '営業', '土木', '警備', '管理', '事務', '飲食', '事務職', 'コールセンター', 'エンジニア', 'インターネット', 'SE', 'NPO', '福祉', '映像', '学校法人', '介護', '講師', '医師', '接客', '不動産', '接客業', '看護', '受付', '交通', '公務員', '動物', 'サービス', '製造', '配送', '販売', 'データ入力', 'アパレル', 'スポーツ', '印刷', '制作', '人事', 'クリニック', '開発', '保育', 'サポート', '機械', '運営', '食品', 'プラスチック成形', '土日勤務', '運動経験', 'データ検査', 'アニメ声優', '東大阪市立日新高等学校', '土木施工管理', '情報環境科', '洋服販売', 'エリアマネジャー', 'ビジネススクール', '中古ジュエリー販売', '岡山', 'お寿司の製造', '期間工', '教育関係', '接客応対', '舞台設備工事', '倉庫オペレータ', '会計税務アシスタント', '売り場づくり', '保育士補助', 'ECサイトの運営業務', '障害者移動支援', 'バル', '小学校通訳', '経理総務事務', 'アミューズメントパーク', '材料技術', '陸送業務', 'IT職種', '総合受付業務', '損保事務', 'ITインフラエンジニア', '医療技術短期大学部', '保育園看護師', '軽貨物運送事業', '漫画家', 'エアジャパン', '成田国際空港', 'アトラクションメンテナンス', 'オンライン決済代行業', '総務部', '建設用軽仮設機材', '子育て支援員', '回収車', '尾瀬高等学校', '洗車', 'フィギュア買い取り', '広島県立安西高等学校', '日立エレベーターサービス株式会社', '大型ダンプ運転手', '損害保険調査', 'プロダクトデザイナー', '熊本県立八代高等学校', 'コンタクトセンター', '物流倉庫内のクール便の仕分け作業', '鮮魚部門', '事務調達職', '千葉県立市原高等学校', '日本化粧品検定2級合格', '千葉県立成田北高等学校', '美容外科 受付 サポート 事務', '財務事務', '医療IT業界', '金属プレス', '営業経験', '土地仕入業務', '医療・保育・介護', '事務リーダー', '人材営業', 'MR', '文章構成', '子供英語講師', '筋力トレーニング', '大型自動車免許', '生産技術業務', '化学生命工学', 'スフォリアテッラ専門店', 'トラブル解決', 'ネットショップ', '事務一般', '短大', '大阪大学人間科学部人間科学科', '製造ライン', 'アプリケーション開発', '石油化学プラント オペレーター', 'Web', '医学技術', '福祉心理', '法務事務', '技術専門', '競走馬', '郵便配達', '飲食サービス', '提案営業', '茨城県立ルネサンス高等学校', '製造工場', 'インテリア業界', '弁護士', '成田空港地上職', '広島市立舟入高等学校', '大学事務員', 'リユース業', '文化財学科', '短期アルバイト', 'EC店鋪運営', '医療サービス業', '医師事務作業補助者', '製袋機オペレーター', '物流企画', '給排水処理設備の運転管理', '通信', '物流倉庫スタッフ', '第二種電気工事士', 'カバーディーラー', '国際英語学科', 'アトラクション運営', '横浜駅周辺', '送電線業界の建設土木', 'データマネージャー', '美術科', '介護施設', '総合事務', '東洋大学', '食物調理', '理学療法', '会計・税務知識', '生活支援員', '旅行業界', '生活相談員', 'パソコン作業', '土木建設業', 'ロボット工学', '施工管理アシスタント', '食品栄養学', '教育支援', '情報専門学校', '設備メンテナンス', 'PC業務', '買取営業', '介護事務', '医療従事者', 'インテリア・住宅関連', '工事現場管理', 'ネットワーク', '訪問介護', '不動産管理', '医療機関', '配達ドライバー', 'メンテナンス', '日本の仕事', '航空貨物', 'インサイドセールス', 'サッカー', 'システムエンジニア・プログラマ', '佐賀県立佐賀農業高等学校', '国際関係学', '社長秘書', '英語力', 'カラオケ', '総務職', '副業', '文学', '経営コンサルタント', '喫茶店', '総務経理事務', 'キッチン', '人材紹介', '工業化学', '病棟クラーク', '指導員', 'テクニカルスタッフ', '音楽講師', '倉庫内作業', 'デンソー', '組立', 'セレクトショップ', '障がい者支援', '警備員', '国際営業', '派遣', '美容室受付', '心理カウンセリング', '鮮魚', '文学部', '倉庫', '営業サポート', '普通自動車第一種運転免許取得', '外国語学部', 'ビジネスマネジメント', '受付兼助手', '医学部', '映像編集', '建築設備点検', '鉄道', '経営学科', '英会話講師', '営業事務職', '人事職', 'デジタルマーケティング', 'SNSマーケティング', '獣医', '自衛隊', '養護教諭', '短期バイト', 'Web開発', 'ホテル業界', '事務・秘書・受付', '看護助手', 'トラック運転手', '国際経済学', 'ルート営業', 'webデザイナー', '調剤薬局事務', '金融業務', '法政大学', '携帯電話販売', 'プログラマー', '設備管理', '仕分け', 'ゲーム業界', '臨床検査技師', 'CADオペレーター', 'WEBデザイン', '陸上自衛隊', '動物看護', '製造業務', '神社', '経理業務', '倉庫作業', '地理学', '医療機器', '事務業務', '物流業', 'システムエンジニア', '建築設計', '英米文学', '製造オペレーター', '歯科技工士', '高校生', '司書', '日本文学', '歯科', '国際経営', 'ITエンジニア', 'カウンセラー', '運転', '人材コーディネーター', '機械工学', '運送業', 'ファッションデザイン', '新卒', 'インフラエンジニア', '製造職', '工場勤務', '製菓', '販売業務', '経営学部', '日本文化', '整備士', '料理', '法人営業', 'パティシエ', 'DTPオペレーター', '法務', '自動車整備士', '早稲田大学', '飲食店', '医療法人', '経理事務', '事務作業', '倉庫管理', '総務事務', 'システム開発', 'ものづくり', '受付業務', '調剤事務', '介護福祉士', 'グラフィックデザイン', '情報処理', '調理', '財務', '自動車販売', 'ドライバー', '接客業務', 'データ分析', '食品製造', '経営学', '管理栄養士', '士業', 'ゲーム開発', '品質管理', '社会福祉', '銀行', '法律', '生産管理', 'IT業界', '受付事務', '販売員', '建設業', '不動産業', '心理学', 'レジャー', '大学卒業後', 'アルバイト', 'コンサルタント', '翻訳', '物流', '通訳', '販売職', '編集', '工事', '経済学', '会計', 'デザイナー', 'プログラミング', '理容', '音楽', 'ブライダル', '建築', '映画', 'マネージャー', '点検', '設計', '化粧品', 'エステ', 'フード', '清掃', '金融', 'イベント', 'プロジェクトマネージャー', 'クリエイティブ'],
      dfBlob: null,
      joblistPrefs: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県', '海外'],
      loginContext: null // ログインした時のコンテキストを保存
    }
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      this.updatePreviewHTML()
      const formData = new FormData()
      // console.error(this.basicData)
      // console.error(this.basicData.lastName)
      let _data = this.cleanedPreviewHtml.replace('\u0000', '')
      // console.error(_data)
      // console.error(this.cleanedPreviewHtml)
      // formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('app_html', _data)
      formData.append('pdf_option', 'A4')
      // formData.append('pdf_option', 'A4ShowPageNumberFooter')
      return formData
    },
    previewDialogStyleObject: function () {
      if (this.previewDialogVisible) {
        return {
          visibility: 'visible',
          height: 'auto'
        }
      } else {
        return {
          visibility: 'hidden',
          overflow: 'hidden',
          height: 0
        }
      }
    },
    isDevelopment: function () {
      return process.env.NODE_ENV === 'development'
    },
    sampleData: function () {
      if (this.currentFormat.sampleData) {
        return this.currentFormat.sampleData
      }
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    exampleSentences: function () {
      if (this.currentFormat.exampleSentences) {
        return this.currentFormat.exampleSentences
      }
      return {}
    },
    firstCardId: function () {
      return this.currentFormat.cards[0].id
    },
    isNextCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex + 1 < this.currentFormat.cards.length
    },
    isPrevCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex > 0
    },
    currentCardIndex: function () {
      if (!this.currentCardId) return -1
      let key, card
      for (key in this.currentFormat.cards) {
        card = this.currentFormat.cards[key]
        if (this.currentCardId === card.id) {
          return Number(key)
        }
      }
      return -1
    },
    currentCardTitle: function () {
      if (!this.currentCardId) return ''
      return this.currentFormat.cards[this.currentCardIndex].title
    },
    currentCardPreviewJumpId: function () {
      if (!this.currentCardId) return ''
      return this.currentFormat.cards[this.currentCardIndex].previewJumpId
    },
    nextCardLabel: function () {
      if (this.isNextCardAvailable) {
        return this.currentFormat.cards[this.currentCardIndex + 1].title
      }
      return ''
    },
    prevCardLabel: function () {
      if (this.isPrevCardAvailable) {
        return this.currentFormat.cards[this.currentCardIndex - 1].title
      }
      return ''
    },
    fontOptions: function () {
      if (this.$globalVar.isYagiPrime) {
        return [
          {
            value: "font-family: 'Noto Sans JP', sans-serif;",
            label: 'Noto Sans JP'
          },
          {
            value: "font-family: 'Noto Serif JP', serif;",
            label: 'Noto Serif JP'
          },
          {
            value: "font-family: 'Zen Maru Gothic', sans-serif;",
            label: 'yagishゴシック'
          },
          {
            value: "font-family: 'BIZ UDPMincho', serif;",
            label: 'yagish明朝'
          },
          {
            value: "font-family: 'DotGothic16', sans-serif;",
            label: 'ドットゴシック16'
          },
          {
            value: "font-family: 'Kiwi Maru', serif;",
            label: 'Kiwi Maru'
          },
          {
            value: "font-family: 'Klee One', cursive;",
            label: 'Klee One'
          },
          {
            value: "font-family: 'Kosugi', sans-serif;",
            label: 'Kosugi'
          },
          {
            value: "font-family: 'Zen Kurenaido', sans-serif;",
            label: 'Zen Kurenaido'
          }
        ]
      } else {
        return [
          {
            value: "font-family: 'Noto Sans JP', sans-serif;",
            label: 'Noto Sans JP'
          },
          {
            value: "font-family: 'Noto Serif JP', serif;",
            label: '🔒️ Noto Serif JP'
          },
          {
            value: "font-family: 'Zen Maru Gothic', sans-serif;",
            label: '🔒️ yagishゴシック'
          },
          {
            value: "font-family: 'BIZ UDPMincho', serif;",
            label: '🔒️ yagish明朝'
          },
          {
            value: "font-family: 'DotGothic16', sans-serif;",
            label: '🔒️ ドットゴシック16'
          },
          {
            value: "font-family: 'Kiwi Maru', serif;",
            label: '🔒️ Kiwi Maru'
          },
          {
            value: "font-family: 'Klee One', cursive;",
            label: '🔒️ Klee One'
          },
          {
            value: "font-family: 'Kosugi', sans-serif;",
            label: '🔒️ Kosugi'
          },
          {
            value: "font-family: 'Zen Kurenaido', sans-serif;",
            label: '🔒️ Zen Kurenaido'
          }
        ]
      }
    }
  },
  methods: {
    preventNav(e) {
      // alert(123)
      // if (!this.$firebase.isAuthenticated) {
      //   e.preventDefault()
      //   e.returnValue = ''
      //   this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
      // }
    },
    loadCurrentFormat: function () {
      const result = this.$site.getFormatById(this.formatId)
      if (result) {
        this.currentFormat = result
      } else {
        console.error('result not found:', this.formatId, result)
      }
    },
    dumpData: function () {
      return JSON.stringify({
        'basicData': this.basicData,
        'formatData': this.formatData
      }, null, 2)
    },
    previewScrollTo: function (id) {
      if (!id) {
        return
      }
      this.$nextTick(function () {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'center'
          })
        }
      })
    },
    openIntroduction: function () {
      this.$eventHub.$emit('open-introduction-dialog', this.formatId, this.$refs.previewFormat)
    },
    showTempdata: function () {
      this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
    },
    showPreviewTest: function () {
      console.error('showPreviewTest')
      if (!this.fontPaymented) {
        this.formatData.selFont = "font-family: 'Noto Sans JP', sans-serif;"
      }
      this.selectFont()
      this.setPreviewScale()
      this.getQrcode()
      this.$nextTick(function () {
        // this.previewScrollTo(this.currentCardPreviewJumpId)
        this.$refs.previewConfirmFormat.checkValid()
      })
    },
    showPreview: function () {
      console.error('showPreview')
      if (!this.fontPaymented) {
        this.formatData.selFont = "font-family: 'Noto Sans JP', sans-serif;"
      }
      this.selectFont()
      this.previewDialogVisible = true
      this.previewTabActive = 'previewFormat'
      this.setPreviewScale()
      this.$router.push({
        name: 'formatPreview',
        params: {
          formatId: this.formatId,
          cardId: this.cardId
        }
      })
      this.$nextTick(function () {
        this.getQrcode()
        this.previewScrollTo(this.currentCardPreviewJumpId)
      })
      // const app = this
      // this.$iterateStorage(function (value, key, iterationNumber) {
      //   if (key === 'basicData') {
      //     app.username = value.lastName + '' + value.firstName
      //     for (const labelName in app.fontOptions) {
      //       // app.fontOptions[label_name].label = app.username + 'さんの履歴書（' + app.fontNames[label_name].label + '）'
      //       app.fontOptions[labelName].label = '履歴書フォント（' + app.fontNames[labelName].label + '）'
      //     }
      //   }
      // }, function (err) { })
      this.$eventHub.$emit('show-preview-from-card', this.currentCardPreviewJumpId)
    },
    showPreview4Conv: function () {
      console.log('=== FormatEdit.showPreview4Conv 開始 ===')
      console.log('this.formatId:', this.formatId)
      console.log('this.$refs.previewFormat:', this.$refs.previewFormat)
      console.log('this.formatData.selFontStyle4DB:', this.formatData.selFontStyle4DB)
      
      if (this.getMode === 'production') {
        console.log('production mode - emitting open-eprint-dialog')
        this.$eventHub.$emit('open-eprint-dialog', this.formatId, this.$refs.previewFormat, this.formatData.selFontStyle4DB)
      } else {
        console.log('non-production mode - emitting open-eprint-dialog')
        this.$eventHub.$emit('open-eprint-dialog', this.formatId, this.$refs.previewFormat, this.formatData.selFontStyle4DB)
      }
      this.saveBackup()
      // // this.displayPopup()
      // this.saveBackup()
      // this.previewDialogVisible = true
      // this.previewTabActive = 'previewFormat'
      // this.setPreviewScale()
      // this.$router.push({
      //   name: 'formatPreview',
      //   params: {
      //     formatId: this.formatId,
      //     cardId: this.cardId
      //   }
      // })
      // this.getQrcode()
      // this.$nextTick(function () {
      //   this.previewScrollTo(this.currentCardPreviewJumpId)
      // })
      // this.$eventHub.$emit('show-preview-from-card', this.currentCardPreviewJumpId)
    },
    closePreview: function () {
      this.previewDialogVisible = false
      if (this.cardId) {
        this.$router.push({
          name: 'formatEditCard',
          params: {
            formatId: this.formatId,
            cardId: this.cardId
          }
        })
      }
    },
    setRecentEdit: function (data) {
      if (!data) {
        data = {
          timestamp: new Date().getTime(),
          FormatId: this.formatId,
          FormatTitle: this.currentFormat.title,
          cardId: this.currentCardId,
          cardTitle: this.currentCardTitle
        }
      }
      this.$setItem(RECENT_EDIT_SAVE_KEY, data)
      this.$eventHub.$emit('change-recent-edit', data)
    },
    setPreviewScale: function () {
      let viewerRef = this.$refs.previewViewer
      this.$nextTick(function () {
        if (!viewerRef) return
        if (this.previewTabActive === 'sampleFormat') {
          const clientWidth = this.$refs[this.previewTabActive].$el.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        } else {
          const clientWidth = this.$refs.previewViewer.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      if (!this.$refs[this.previewTabActive]) {
        console.log('!this.$refs[this.previewTabActive]', this.$refs[this.previewTabActive])
        return
      }
      if (!this.$refs[this.previewTabActive].$refs.previewMain) {
        console.log('!this.$refs[this.previewTabActive].$refs.previewMain', this.$refs[this.previewTabActive].$refs.previewMain)
        return
      }
      const height = this.$refs[this.previewTabActive].$refs.previewMain.getBoundingClientRect().height
      if (!height) {
        return
      }
      this.previewViewerCss = {
        height: height + 30 + 'px'
      }
    },
    cardIdExists: function (cardId) {
      for (const key in this.currentFormat.cards) {
        if (this.currentFormat.cards[key].id === cardId) {
          return true
        }
      }
      return false
    },
    goFirstCard: function () {
      // $routerが存在するか確認
      if (!this.$router) {
        console.error('ルーターが初期化されていません')
        return
      }

      try {
        this.$router.replace({
          name: 'formatEditCard',
          params: {
            formatId: this.currentFormat.id,
            cardId: this.firstCardId
          }
        }).then(() => {
        }).catch(error => {
          console.error(`ルーター遷移エラー: ${error.message}`)
        })
      } catch (error) {
        console.error(`ルーター遷移中に例外が発生しました: ${error.message}`)
      }
    },
    goCurrentCard: async function () {
      // const app = this
      console.error('goCurrentCard')
      if (!this.fontPaymented) {
        this.formatData.selFont = "font-family: 'Noto Sans JP', sans-serif;"
      }
      this.selectFont()
      this.setPreviewScale()
      this.previewDialogVisible = false
      this.$router.push({
        name: 'formatEditCard',
        params: {
          formatId: this.currentFormat.id,
          cardId: this.currentCardId
        }
      })
      this.setRecentEdit()
      this.$eventHub.$emit('deactivate-history-item')
      this.$eventHub.$emit('card-changed', this.currentCardId)
      this.$nextTick(function () {
        this.showPreviewTest()
      })
      // if (this.currentCardId === 'output') {
      //   if (false) {
      //     const formData = new FormData()
      //     formData.append('uuid', this.$firebase.user.uid)
      //     let storageData = {}
      //     await this.$iterateStorage(
      //       function (value, key, iterationNumber) {
      //         if (_.includes(BACKUP_KEYS_LIST, key)) {
      //           storageData[key] = value
      //         }
      //       },
      //       function (err) {
      //         if (err) {
      //           console.error(err)
      //         }
      //       }
      //     )
      //     formData.append('storage_data', JSON.stringify(storageData))
      //     this.$axios
      //       .post(this.$varuna.endPoints.getDisableRtCondition, formData, { timeout: 60000 })
      //       .then(function (response) {
      //         app.disableRtCondition = response.data
      //       })
      //       .catch(function (error) {
      //       }).finally(function () {
      //       })
      //   }
      // }
    },
    scrollToCurrentStep: function () {
      this.$nextTick(function () {
        if (this.currentCardIndex < 0) {
          return
        }
        this.$refs.steps[this.currentCardIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'center'
        })
      })
    },
    goCardTo: function (cardId) {
      if (!this.cardIdExists(cardId)) {
        this.goFirstCard()
        return
      }

      // if (this.currentCardId == 'requests' && cardId == 'create-date' && false) {
      //   if (this.formatData.registYagioffer && this.formatId == 'rirekisho_job_new') {
      //     if (this.formatData.registYagioffer) {
      //       let msg = ''
      //       if (!this.formatData.department) {
      //         msg = msg + '[学部・学科]'
      //       }
      //       if (!this.formatData.hopeAreaPref) {
      //         msg = msg + '[希望勤務地]'
      //       }
      //       if (!this.formatData.hopeIndustry) {
      //         msg = msg + '[希望業界]'
      //       }
      //       if (!this.formatData.hopeJobcategory) {
      //         msg = msg + '[希望職種]'
      //       }
      //       if (msg) {
      //         this.$alert('ヤギオファー登録のため、' + msg + 'を選択してください', '入力エラー', {
      //           confirmButtonText: 'OK',
      //           type: 'warning',
      //           callback: action => {
      //           }
      //         })
      //         return

      //       }

      //     }
      //     // const app = this
      //     // const formData = new FormData()
      //     // formData.append('uuid', this.$firebase.user.uid)
      //     // formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      //     // formData.append('version', '2')
      //     // formData.append('reqflg', '2')

      //     // formData.append('hope_area_pref', this.formatData.hopeAreaPref)
      //     // formData.append('hope_industry', this.formatData.hopeIndustry)
      //     // formData.append('department', this.formatData.department)
      //     // formData.append('hope_jobcategory', this.formatData.hopeJobcategory)
      //     // formData.append('graduation_year', this.formatData.gradeYear)

      //     // this.$axios
      //     //   .post(this.$varuna.endPoints.registYagiofferMember, formData, {timeout: 60000})
      //   }
      // }

      this.currentCardId = cardId
      this.goCurrentCard()
      this.scrollToCurrentStep()
      if (!this.$firebase.isAuthenticated) {
        if (this.currentCardId === 'address' || this.currentCardId === 'license-history') {
          // this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
        }
      }
    },
    goNextCard: function () {
      if (this.isNextCardAvailable) {
        // if (this.currentFormat.cards[this.currentCardIndex + 1].id == 'create-date' && false) {
        //   if (this.formatData.registYagioffer && this.formatId == 'rirekisho_job_new') {
        //     if (this.formatData.registYagioffer) {
        //       let msg = ''
        //       if (!this.formatData.department) {
        //         msg = msg + '[学部・学科]'
        //       }
        //       if (!this.formatData.hopeAreaPref) {
        //         msg = msg + '[希望勤務地]'
        //       }
        //       if (!this.formatData.hopeIndustry) {
        //         msg = msg + '[希望業界]'
        //       }
        //       if (!this.formatData.hopeJobcategory) {
        //         msg = msg + '[希望職種]'
        //       }
        //       if (msg) {
        //         this.$alert('ヤギオファー登録のため、' + msg + 'を選択してください', '入力エラー', {
        //           confirmButtonText: 'OK',
        //           type: 'warning',
        //           callback: action => {
        //           }
        //         })
        //         return

        //       }

        //     }
        //     // const app = this
        //     // const formData = new FormData()
        //     // formData.append('uuid', this.$firebase.user.uid)
        //     // formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
        //     // formData.append('version', '2')
        //     // formData.append('reqflg', '2')

        //     // formData.append('hope_area_pref', this.formatData.hopeAreaPref)
        //     // formData.append('hope_industry', this.formatData.hopeIndustry)
        //     // formData.append('department', this.formatData.department)
        //     // formData.append('hope_jobcategory', this.formatData.hopeJobcategory)
        //     // formData.append('graduation_year', this.formatData.gradeYear)

        //     // this.$axios
        //     //   .post(this.$varuna.endPoints.registYagiofferMember, formData, {timeout: 60000})
        //   }
        // }

        this.currentCardId = this.currentFormat.cards[this.currentCardIndex + 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
        // if (!this.$firebase.isAuthenticated) {
        //   if (this.currentCardId == 'address' || this.currentCardId == 'license-history' || this.currentCardId == 'output') {
        //     this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
        //   }
        // }
      }
    },
    goPrevCard: function () {
      if (this.isPrevCardAvailable) {
        this.currentCardId = this.currentFormat.cards[this.currentCardIndex - 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    goDownloadCard: function () {
      this.goCardTo('output')
    },
    swipeNextCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goNextCard()
      }
    },
    swipePrevCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goPrevCard()
      }
    },
    updateFormatData: function (data) {
      this.formatData = data
      this.downloadPdfEnabled = true
    },
    updateFormatOtherData: function (data) {
      console.error(data)
      this.otherFormatData = data
    },
    updateBasicData: function (data) {
      this.basicData = data
      this.downloadPdfEnabled = true
    },
    saveNotify: function () {
      const now = new Date()
      this.$setItem(LAST_SAVE_DATE_SAVE_KEY, now)
      this.saveDate = now
      this.updateSaveNotifyMessage()
    },
    updateSaveNotifyMessage: function () {
      if (this.saveDate) {
        this.saveNotifyMessage = timeAgo(this.saveDate)
      } else {
        this.saveNotifyMessage = ''
      }
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.currentFormat.id}${dateString}.${ext}`
    },
    updatePreviewHTML: function () {
      if (this.$refs.previewFormat) {
        this.previewHtml = this.$refs.previewFormat.$el.innerHTML
      } else {
        console.error('this.$refs.previewFormat', this.$refs)
      }
    },
    setPreviewHtml: function () {
      this.updatePreviewHTML()
      const param = {
        app_html: this.cleanedPreviewHtml
      }
      this.submitForm(this.$varuna.endPoints.html, param, 'POST')
    },
    saveDownloadLog: function (pdfBlob, filename) {
      // PDF Download log
      if (this.$firebase.isAuthenticated) {
        this.$firebase.addPdfDownloadLog(
          this.currentFormat.id,
          this.currentFormat.title, {
          formatData: this.formatData,
          basicData: this.basicData
        },
          pdfBlob,
          filename
        )
      }
    },
    loadPdfBlob: function () {
      /*
      PDFプレビューテスト用
      */
      const previewOpened = this.previewDialogVisible
      if (!previewOpened) {
        this.previewDialogVisible = true
      }
      const filename = this.createFilename('pdf')
      const app = this
      this.$nextTick(async function () {
        this.updatePreviewHTML()
        const formData = this.pdfFormData
        formData.append('version', '2')
        formData.append('app_flag', app.$site.appFlag)
        formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')


        let storageData = {}
        await app.$iterateStorage(
          function (value, key, iterationNumber) {
            if (_.includes(BACKUP_KEYS_LIST, key)) {
              storageData[key] = value
            }
          },
          function (err) {
            if (err) {
              console.error(err)
            }
          }
        )
        let _bdata = JSON.stringify(storageData)
        formData.append('storage_data', _bdata)


        let pdfurl = this.$varuna.endPoints.pdf
        if (this.formatId === 'rirekisho_design_001') {
          formData.append('design_flag', '1')
          formData.append('design_color_01', '#eef5e8')
          formData.append('design_color_02', '#0f9934')
          pdfurl = this.$varuna.endPoints.pdfDesign
        }
        this.$axios({
          url: pdfurl + filename,
          method: 'post',
          data: formData,
          responseType: 'blob',
          timeout: 60000
        }).then((response) => {
          const pdfBlob = new Blob([response.data], {
            type: 'application/pdf'
          })
          this.pdfBlob = window.URL.createObjectURL(pdfBlob)
        }).catch(function (error) {
          app.$message({
            message: 'ダウンロードに失敗しました。しばらくしてからやり直してください',
            type: 'error'
          })
          app.downloadPdfEnabled = true
          console.error(error)
          app.$gtm.sendError('pdf download', `download pdf failed ${error}`)
        })
      })
      if (!previewOpened) {
        this.previewDialogVisible = false
      }
    },
    downloadPDFWithLink: function () {
      this.$globalVar.dn_flag = 'dn'
      /*
      <a download="filename">を使う
      jsでPDFのBlobを受け取れるからログに保存できる
      IEでは動かない
      */
      const previewOpened = this.previewDialogVisible
      if (!previewOpened) {
        this.previewDialogVisible = true
      }
      const filename = this.createFilename('pdf')
      const app = this
      this.$nextTick(async function () {
        this.updatePreviewHTML()
        const formData = this.pdfFormData
        formData.append('version', '2')
        formData.append('format_id', app.formatId)
        formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
        formData.append('uuid', app.$firebase.user.uid)
        formData.append('app_flag', app.$site.appFlag)
        formData.append('font_name', app.formatData.selFontStyle4DB)


        let storageData = {}
        await app.$iterateStorage(
          function (value, key, iterationNumber) {
            if (_.includes(BACKUP_KEYS_LIST, key)) {
              storageData[key] = value
            }
          },
          function (err) {
            if (err) {
              console.error(err)
            }
          }
        )
        let _bdata = JSON.stringify(storageData)
        formData.append('storage_data', _bdata)


        let pdfurl = this.$varuna.endPoints.pdf
        if (this.formatId === 'rirekisho_design_001') {
          formData.append('design_flag', '1')
          formData.append('design_color_01', '#eef5e8')
          formData.append('design_color_02', '#0f9934')
          pdfurl = this.$varuna.endPoints.pdfDesign
        }
        this.$axios({
          url: pdfurl + filename,
          method: 'post',
          data: formData,
          responseType: 'blob',
          timeout: 40000
        }).then((response) => {
          app.saveBackup()
          const pdfBlob = new Blob([response.data], {
            type: 'application/pdf'
          })
          if (app.$deviceLib.isMobileDevice) {
            const url = window.URL.createObjectURL(pdfBlob)
            let link = document.createElement('a')
            link.href = '/download?filename=' + filename + '&blob=' + url
            link.target = '_blank'
            // console.error(link)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          } else {
            const url = window.URL.createObjectURL(pdfBlob)
            // saveDownloadLog(pdfBlob, filename)
            let link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }).catch(function (error) {
          app.$message({
            message: 'ダウンロードに失敗しました。しばらくしてからやり直してください',
            type: 'error'
          })
          app.downloadPdfEnabled = true
          console.error(error)
          app.$gtm.sendError('pdf download', `download pdf failed ${error}`)
        })
      })
      if (!previewOpened) {
        this.previewDialogVisible = false
      }
    },
    downloadPDFWithForm: function (forceDownload) {
      this.$globalVar.dn_flag = 'dn'
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.previewDialogVisible = true
      this.$nextTick(function () {
        this.updatePreviewHTML()
        let pdfURL = this.$varuna.endPoints.pdf
        if (forceDownload) {
          pdfURL = this.$varuna.endPoints.pdfDownload
        }
        if (this.formatId === 'rirekisho_design_001') {
          formData.append('design_flag', '1')
          formData.append('design_color_01', '#eef5e8')
          formData.append('design_color_02', '#0f9934')
          pdfURL = this.$varuna.endPoints.pdfDesign
          if (forceDownload) {
            pdfURL = this.$varuna.endPoints.pdfDesignDownload
          }
        }
        const param = {
          app_html: this.cleanedPreviewHtml
        }
        this.submitForm(pdfURL + this.createFilename('pdf'), param, 'POST')
      })
    },
    downloadPDF: function () {

      const nowdate2 = new Date()
      console.error(nowdate2)
      this.$globalVar.dn_flag = 'dn'
      this.displayPopup()
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      if (this.$deviceLib.isIE) {
        this.downloadPDFWithForm(true)
      } else {
        this.downloadPDFWithLink()
      }
    },
    saveBackup: function () {
      if (this.$yagi.profile.name) {
        this.saveLabel = this.$yagi.profile.name + 'のバックアップ'
      } else {
        this.saveLabel = 'バックアップ'
      }
      this.updatePreviewHTML()
      // console.error(this.cleanedPreviewHtml)
      let _data = this.cleanedPreviewHtml.replace('\u0000', '')
      // console.error(_data)
      this.$firebase.addBackup(this.saveLabel, 'user', false, this.formatId, _data)
    },
    keywordCheck: function (keyword) {
      let _check = false
      if (this.formatId === 'shokumukeirekisho') {
        return false
      }
      for (let key in this.formatData.educationalHistories) {
        // 見出し
        let item = this.formatData.educationalHistories[key]
        if (item.description && item.description.indexOf(keyword) >= 0) {
          _check = true
        }
      }
      for (let key in this.formatData.jobHistories) {
        // 見出し
        let item = this.formatData.jobHistories[key]
        if (item.description && item.description.indexOf(keyword) >= 0) {
          _check = true
        }
      }
      for (let key in this.formatData.licenseHistories) {
        // 見出し
        let item = this.formatData.licenseHistories[key]
        if (item.description && item.description.indexOf(keyword) >= 0) {
          _check = true
        }
      }
      return _check
    },
    keywordCheck2: function (keyword) {
      let _check = false
      if (this.formatId === 'shokumukeirekisho') {
        return false
      }
      for (let key in this.formatData.educationalHistories) {
        // 見出し
        let item = this.formatData.educationalHistories[key]
        if (item.description.indexOf(keyword) >= 0) {
          _check = true
        }
      }
      for (let key in this.formatData.licenseHistories) {
        // 見出し
        let item = this.formatData.licenseHistories[key]
        if (item.description.indexOf(keyword) >= 0) {
          _check = true
        }
      }
      return _check
    },
    keywordCheck3xx: function (keyword) {
      let _check = false
      return _check
    },
    keywordCheck3: function (keyword) {
      let _check = false

      if (this.formatData.prMessage && this.formatData.prMessage.indexOf(keyword) >= 0) {
        _check = true
      }
      if (this.formatData.jobSummary && this.formatData.jobSummary.indexOf(keyword) >= 0) {
        _check = true
      }
      if (this.formatData.jobHistories) {
        for (let key in this.formatData.jobHistories) {
          // 見出し
          let item = this.formatData.jobHistories[key]
          if (item && item.businessArea && item.businessArea.indexOf(keyword) >= 0) {
            _check = true
          }
          for (let subkey in item.projects) {
            let subitem = item.projects[subkey]
            if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keyword) >= 0) {
              _check = true
            }
            if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keyword) >= 0) {
              _check = true
            }
            if (subitem && subitem.position && subitem.position.indexOf(keyword) >= 0) {
              _check = true
            }
          }
        }
      }
      return _check
    },
    keywordCheckRirekisho: function (targetData, keywordlist) {
      for (const keyword in keywordlist) {
        for (let key in targetData.educationalHistories) {
          // 見出し
          let item = targetData.educationalHistories[key]
          if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
            return true
          }
        }
        for (let key in targetData.jobHistories) {
          // 見出し
          let item = targetData.jobHistories[key]
          if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
            return true
          }
        }
        for (let key in targetData.licenseHistories) {
          // 見出し
          let item = targetData.licenseHistories[key]
          if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
            return true
          }
        }
      }
      return false
    },
    keywordCheckShokumukeirekisho: function (targetData, keywordlist) {
      for (const keyword in keywordlist) {
        if (targetData.prMessage && targetData.prMessage.indexOf(keywordlist[keyword]) >= 0) {
          return true
        }
        if (targetData.jobSummary && targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0) {
          return true
        }
        if (targetData.skillsToUse) {
          for (let key in targetData.skillsToUse) {
            let item = targetData.skillsToUse[key]
            if (item && item.skillname && item.skillname.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
          }
        }
        if (targetData.jobHistories) {
          for (let key in targetData.jobHistories) {
            // 見出し
            let item = targetData.jobHistories[key]
            if (item && item.businessArea && item.businessArea.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            for (let subkey in item.projects) {
              let subitem = item.projects[subkey]
              if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
              if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
              if (subitem && subitem.position && subitem.position.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
          }
        }
      }
      return false
    },
    addressCheck: function (addresslist) {
      for (const key in addresslist) {
        if (this.basicData.address1 && this.basicData.address1.indexOf(addresslist[key]) >= 0) {
          return true
        }
      }
      return false
    },
    displayPopup: async function () {
      const app = this

      var oemId = app.$cookies.get('_YAGISH_OEM_ID')
      if (oemId) return false

      if (app.disableRtCondition) {
        app.$globalVar.displayFrontEndPopupRenew(
          app.formatId,
          app.formatData,
          app.basicData,
          app.otherFormatData,
          app.disableRtCondition,
          app.$refs.previewFormat)
      } else {
        const formData = new FormData()
        formData.append('uuid', this.$firebase.user.uid)
        let storageData = {}
        formData.append('storage_data', JSON.stringify(storageData))
        this.$axios
          .post(this.$varuna.endPoints.getDisableRtCondition, formData, { timeout: 60000 })
          .then(function (response) {
            app.$globalVar.displayFrontEndPopupRenew(
              app.formatId,
              app.formatData,
              app.basicData,
              app.otherFormatData,
              response.data,
              app.$refs.previewFormat)
          })
      }

      // if (false) {
      //   const formData = new FormData()
      //   formData.append('uuid', this.$firebase.user.uid)
      //   let storageData = {}
      //   await this.$iterateStorage(
      //     function (value, key, iterationNumber) {
      //       if (_.includes(BACKUP_KEYS_LIST, key)) {
      //         storageData[key] = value
      //       }
      //     },
      //     function (err) {
      //       if (err) {
      //         console.error(err)
      //       }
      //     }
      //   )
      //   formData.append('storage_data', JSON.stringify(storageData))
      //   this.$axios
      //     .post(this.$varuna.endPoints.getDisableRtCondition, formData, { timeout: 60000 })
      //     .then(function (response) {
      //       if (app.getMode != 'production') {
      //         console.error(app.$globalVar)
      //       } else {
      //         // app.displayFrontEndPopupRenew(response.data)
      //       }

      //       app.$globalVar.displayFrontEndPopupRenew(
      //         app.formatId,
      //         app.formatData,
      //         app.basicData,
      //         app.otherFormatData,
      //         response.data,
      //         app.$refs.previewFormat)
      //     })
      //     .catch(function (error) {
      //     }).finally(function () {
      //     })
      // } else {
      //   // this.displayFrontEndPopupRenew()
      // }
    },
    displayBackEndPopup: function (data) {
      console.error(data.client_condition_id)
      console.error(data.permission_type)
      let dialogName = data.dialog_name
      let permissionType = data.permission_type
      if (dialogName === 'roxx_dialog') {
        this.$eventHub.$emit('open-roxx-dialog', this.formatId, this.$refs.previewFormat, this.basicData.email, permissionType)
      } else if (dialogName === 'kirara_dialog') {
        this.$eventHub.$emit('open-kirara-dialog', this.formatId, this.$refs.previewFormat)
      } else if (dialogName === 'simple_dialog') {
        this.$eventHub.$emit('open-simple-dialog', this.formatId, this.$refs.previewFormat, permissionType)
      } else if (dialogName === 'baton_dialog' && permissionType === 1) {
        this.$eventHub.$emit('open-baton-dialog', this.formatId, this.$refs.previewFormat, 1)
      } else if (dialogName === 'medley_dialog') {
        this.$eventHub.$emit('open-medley-dialog', this.formatId, this.$refs.previewFormat, 1)
      } else {
        this.$eventHub.$emit('open-joblist-dialog', this.formatId, this.$refs.previewFormat, this.checkJoblistKeyword(), this.getPrefJoblist(), this.basicData.age)
      }
    },
    checkJoblistKeyword: function () {
      let _keyword = ''
      for (let key in this.joblistKeyword) {
        if (this.keywordCheck(this.joblistKeyword[key])) {
          _keyword = this.joblistKeyword[key]
          return _keyword
        }
      }
      return _keyword
    },
    getPrefJoblist: function () {
      let _pref = ''
      for (let key in this.joblistPrefs) {
        if (this.basicData.address1.indexOf(this.joblistPrefs[key]) >= 0) {
          _pref = this.joblistPrefs[key]
        }
      }
      return _pref
    },
    mailPDF: async function () {
      const _nowdate2 = new Date()
      console.error(_nowdate2)

      this.$globalVar.dn_flag = 'mail'

      const app = this
      this.displayPopup()
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (this.mailPDFSending) {
        this.$message({
          message: '現在メール送信中です',
          type: 'error'
        })
        return
      }
      if (!this.$firebase.user.email) {
        if (!app.basicData.email) {
          this.$message({
            message: '連絡先にてメールアドレスを入力してください',
            type: 'error'
          })
          return
        }
      } else {
        if (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && !app.basicData.email) {
          this.$message({
            message: '連絡先にてメールアドレスを入力してください',
            type: 'error'
          })
          return
        }
      }
      this.updatePreviewHTML()
      this.mailPDFSending = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('format_id', this.formatId)
      if (!this.$firebase.user.email && app.basicData.email ||
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && app.basicData.email)) {
        formData.append('inputemail', app.basicData.email)
        const subformData = new FormData()
        subformData.append('uuid', this.$firebase.user.uid)
        subformData.append('email', app.basicData.email)
        subformData.append('app_flag', this.$site.appFlag)
        subformData.append('site_flag', 'r')
        subformData.append('email_verified', this.$firebase.useremailVerified ? '1' : '0')
        subformData.append('device_flag', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
        this.$axios
          .post(this.$varuna.endPoints.login, subformData)
        // this.$firebase.user.updateEmail(app.basicData.email).then(() => {
        // }).catch((error) => {
        // });
      }
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('font_name', app.formatData.selFontStyle4DB)
      formData.append('version', '2')



      let storageData = {}
      await this.$iterateStorage(
        function (value, key, iterationNumber) {
          if (_.includes(BACKUP_KEYS_LIST, key)) {
            storageData[key] = value
          }
        },
        function (err) {
          if (err) {
            console.error(err)
          }
        }
      )


      let _bdata = JSON.stringify(storageData)
      formData.append('storage_data', _bdata)

      formData.append('keyword', this.checkJoblistKeyword())
      formData.append('area', this.getPrefJoblist())
      if (this.formatId === 'rerekisho_part_time' ||
        this.formatId === 'rirekisho_part_time2') {
        formData.append('jt', '2')
      } else if (this.formatId === 'rirekisho_job_new' ||
        this.formatId === 'rirekisho_job_new_single' ||
        this.formatId === 'internship') {
        formData.append('jt', '6')
      } else {
        formData.append('jt', '0')
      }
      let pdfurl = this.$varuna.endPoints.pdfMail
      if (this.formatId === 'rirekisho_design_001') {
        pdfurl = this.$varuna.endPoints.pdfDesignMail
      }

      app.saveBackup()
      this.$axios
        .post(pdfurl, formData, { timeout: 60000 })
        .then(function (response) {
          if (!app.$firebase.user.email && app.basicData.email ||
            (app.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && app.basicData.email)) {
            app.$message({
              message: app.basicData.email + 'に送信しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: app.$firebase.user.email + 'に送信しました',
              type: 'success'
            })
          }
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.mailPDFSending = false
        })
    },
    openSCREENSHOT: function () {
      this.updatePreviewHTML()
      const param = {
        app_html: this.cleanedPreviewHtml
      }
      this.submitForm(this.$varuna.endPoints.screenshot + this.createFilename('png'), param, 'POST')
    },
    submitForm: function (url, data, method) {
      const form = document.createElement('form')
      document.body.appendChild(form)
      form.action = url
      form.method = method
      for (const name in data) {
        let input = document.createElement('input')
        input.type = 'hidden'
        input.name = name
        input.value = data[name]
        form.appendChild(input)
      }
      form.submit()
      document.body.removeChild(form)
    },
    hidePreviewDialog: function (e) {
      if (this.previewDialogVisible) {
        this.previewDialogVisible = false
      }
    },
    selectFont: function () {
      // フォント名を表示するための処理を追加
      // 選択されたフォントのCSS値から対応するフォント名を探す
      const selectedFont = this.fontOptions.find(font => font.value === this.formatData.selFont)
      this.formatData.displayFontName = selectedFont ? selectedFont.name : '不明なフォント'

      this.formatData.selFontStyle = this.formatData.selFont
      this.formatData.selFontStyle4DB = this.formatData.selFont
    },
    setPreviewScaleDebounce: function (e) {
      _.debounce(this.setPreviewScale, 1000)
    },
    sendSpecialPost: function (formatId) {
      this.saveBackup()
      // this.displayPopup()
      // this.$router.push('/yagiprimequickmail/basic')
      location.href = '/yagiprimequickmail/basic'
      // if (this.getMode == 'production') {
      //   this.$router.push('/quickmail/basic')
      // } else {
      //   this.$router.push('/yagiprimequickmail/basic')

      // }
    },
    sendQuickEmail: function (formatId) {
      this.saveBackup()
      // this.displayPopup()
      // this.$router.push('/yagiprimequickemail/basic')
      location.href = '/yagiprimequickemail/basic'
      // if (this.getMode == 'production') {
      //   this.$router.push('/quickemail/basic')
      // } else {
      //   this.$router.push('/yagiprimequickemail/basic')

      // }
    },
    sendNewQuickEmail: function (formatId) {
      this.saveBackup()
      // this.displayPopup()
      this.$router.push('/newquickemail/basic')
    },
    sendRecommendRequestShogai: async function () {
      const app = this
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      if (app.basicData.email === '') {
        this.$message({
          message: 'メールアドレスを入力してください',
          type: 'error'
        })
        return
      }
      console.error(this.$formLib.dateFormat(app.limitDate, 'yyyy/mm/dd'))

      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.formatData.introName) {
        this.$message({
          message: 'お願いする相手の姓名を入力してください',
          type: 'warning'
        })
        return
      }
      if (!this.formatData.introEmail) {
        this.$message({
          message: 'お願いする相手のメールアドレスを入力してください',
          type: 'warning'
        })
        return
      }
      if (!this.formatData.requestStatement) {
        this.$message({
          message: 'お願い内容を入力してください',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('intro_name', this.formatData.introName)
      formData.append('request_name', this.basicData.lastName)
      formData.append('request_email', this.basicData.email)
      formData.append('format_id', this.formatId)
      formData.append('intro_email', this.formatData.introEmail)
      formData.append('relationship', this.formatData.relationship)
      formData.append('limit_date', this.$formLib.dateFormat(app.limitDate, 'yyyy/mm/dd'))
      formData.append('request_statement', this.formatData.requestStatement)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('relationship_etc', '')

      var esf_ap_id = this.$cookies.get('_YAGISH_ESF_AP_ID')
      if (esf_ap_id) {
        formData.append('alliance', esf_ap_id)
      }

      formData.append('handbook_kind', this.formatData.handbookKind)
      formData.append('shogai_kind', this.formatData.shogaiKind)
      formData.append('shogai_kind_etc', this.formatData.shogaiKind_etc)
      formData.append('shogai_level', this.formatData.shogaiLevel)
      formData.append('skill_description', this.formatData.skillDescription)
      formData.append('hospital_visit', this.formatData.hospitalVisit)
      formData.append('hospital_visit_description', this.formatData.hospitalVisitDescription)
      formData.append('disorder_feature', this.formatData.disorderFeature)
      formData.append('self_disorder_feature', this.formatData.selfDisorderFeature)
      formData.append('consideration_desired', this.formatData.considerationDesired)

      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')

      this.$axios
        .post(this.$varuna.endPoints.requestShogaiRecommend, formData, { timeout: 60000 })
        .then(function (response) {
          app.saveBackup()
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `推薦依頼を送信しました`,
            type: 'success'
          })
        })
        .catch(function () {
          app.$message({
            duration: 0,
            showClose: true,
            message: '応募に失敗しました。入力内容を確認して再度ご応募ください',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    registYagiofferShogai: async function () {
      const app = this
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      if (app.basicData.email === '') {
        this.$message({
          message: 'メールアドレスを入力してください',
          type: 'error'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }

      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('request_name', this.basicData.lastName)
      formData.append('request_email', this.basicData.email)
      formData.append('handbook_kind', this.formatData.handbookKind)
      formData.append('shogai_kind', this.formatData.shogaiKind)
      formData.append('shogai_kind_etc', this.formatData.shogaiKind_etc)
      formData.append('shogai_level', this.formatData.shogaiLevel)
      formData.append('skill_description', this.formatData.skillDescription)
      formData.append('hospital_visit', this.formatData.hospitalVisit)
      formData.append('hospital_visit_description', this.formatData.hospitalVisitDescription)
      formData.append('disorder_feature', this.formatData.disorderFeature)
      formData.append('self_disorder_feature', this.formatData.selfDisorderFeature)
      formData.append('consideration_desired', this.formatData.considerationDesired)

      var esf_ap_id = this.$cookies.get('_YAGISH_ESF_AP_ID')
      if (esf_ap_id) {
        formData.append('alliance', esf_ap_id)
      }
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')

      this.$axios
        .post(this.$varuna.endPoints.registYagiofferShogai, formData, { timeout: 60000 })
        .then(function (response) {
          app.saveBackup()
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーを受けられるようになりました。`,
            type: 'success'
          })
        })
        .catch(function () {
          app.$message({
            duration: 0,
            showClose: true,
            message: '登録に失敗しました。入力内容を確認して再度ご応募ください',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    getQrcode: function () {
      // console.error("getQrcode:" + this.$firebase.user.uid)
      const app = this
      if (this.formatId === 'rirekisho_job_new') {
        if (app.$firebase.isAuthenticated) {
          const formData = new FormData()
          formData.append('uuid', app.$firebase.user.uid)
          formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
          formData.append('version', '2')
          formData.append('reqflg', '2')

          // app.$axios
          //   .post(this.$varuna.endPoints.getQRcode, formData, { timeout: 60000 })
          //   .then(function (response) {
          //     if (response.data != 'errors:DoesNotExist') {
          //       app.$refs.previewFormat.qr_image = 'data:image/png;base64,' + response.data.qr
          //       app.$refs.previewFormat.qr_link = response.data.link
          //     }
          //   })
          //   .catch(function (error) {
          //     console.log(error)
          //   }).finally(function () {
          //     app.fullscreenLoading = false
          //   })
        }
      }
      if (this.formatId === 'rirekisho_esf_challenged') {
        if (app.$firebase.isAuthenticated) {
          const formData = new FormData()
          formData.append('uuid', app.$firebase.user.uid)
          formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
          formData.append('version', '2')
          formData.append('reqflg', '2')

          app.$axios
            .post(this.$varuna.endPoints.getShogaiQRcode, formData, { timeout: 60000 })
            .then(function (response) {
              if (response.data != 'errors:DoesNotExist') {
                app.$refs.previewFormat.qr_image = 'data:image/png;base64,' + response.data.qr
                app.$refs.previewFormat.qr_link = response.data.link
              }
            })
            .catch(function (error) {
              console.log(error)
            }).finally(function () {
              app.fullscreenLoading = false
            })
        }
      }
      if (this.cardId === 'output' || this.cardId === 'confirm') {
        const currentDateTime = new Date()

        console.error("%&%&%&%&%&%&%%&%&")
        console.error("%&%&%&%&%&%&%%&%&")
        app.$eventHub.$emit('get-carat-list', app.formatId, app.$refs.previewFormat,
          app.$globalVar.checkJoblistKeyword(app.formatId, app.formatData),
          app.$globalVar.getPrefJoblist(app.basicData), app.basicData.age, 1, null, null, app.basicData.address1)


        console.error("%&%&%&%&%&%&%%&%&")
        console.error("%&%&%&%&%&%&%%&%&")

        if (currentDateTime > app.getDisableRtConditionLimitDateTime) {
          const formData = new FormData()
          formData.append('uuid', this.$firebase.user.uid)
          let storageData = {}
          formData.append('storage_data', JSON.stringify(storageData))
          this.$axios
            .post(this.$varuna.endPoints.getDisableRtCondition, formData, { timeout: 60000 })
            .then(function (response) {
              app.disableRtCondition = response.data
              app.getDisableRtConditionLimitDateTime = new Date(currentDateTime);
              app.getDisableRtConditionLimitDateTime.setMinutes(app.getDisableRtConditionLimitDateTime.getMinutes() + 100)
            })
            .catch(function () {
            }).finally(function () {
            })
        }
      }

      if (app.$firebase.isAuthenticated && app.getMode !== 'production1') {
        this.$axios
          .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
          .then(function (response) {
            console.error(response.data.is_subscribed)
            if (response.data.is_subscribed) {
              app.$globalVar.isYagiPrime = true
              app.fontPaymented = true
            }
          })

        this.$axios
          .post(this.$varuna.endPoints.getFontpayment, formData, { timeout: 60000 })
          .then(function (response) {
            console.error(response.data.payment_flag)
            if (response.data.payment_flag == '1') {
              app.fontPaymented = true
            }
          })
          .catch(function () {
          }).finally(function () {
          })
      }

    },
    getFontpayment: function (_user) {

      this.$nextTick(function () {
        console.error(this.$firebase.isAuthenticated)
        if (this.$firebase.isAuthenticated) {
          const app = this

          const formData = new FormData()
          formData.append('uuid', this.$firebase.user.uid)

          this.$axios
            .post(this.$varuna.endPoints.getFontpayment, formData, { timeout: 60000 })
            .then(function (response) {
              console.error(response.data.payment_flag)
              if (response.data.payment_flag === '1') {
                app.fontPaymented = true
              }
            })
            .catch(function () {
            }).finally(function () {
            })

        }
      })
    },
    sendYagishIntern: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatId)
      formData.append('yaginame', '応募者')
      formData.append('client_id', 'yagish_intern')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'intern_page')
      formData.append('permission_type', 4)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.yagishRecruitPdfMail, formData, { timeout: 60000 })
        .then(function (response) {
          app.$eventHub.$emit('set_is_sendedYagishIntern', true)
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendEmailVerification: async function () {
      const app = this
      await this.$firebase.user.sendEmailVerification().then(() => {
        app.$message({
          message: '送信しました。メール内のリンクをクリックしてください',
          type: 'success'
        })

      }).catch(function () {
        app.$message({
          message: '送信失敗しました。',
          type: 'error'
        })
      })
    },
    getFontPaymented: function () {
      console.error('getFontPaymented:' + this.fontPaymented)
      return this.fontPaymented
    },
    updateRtCondition: function (client_id, permission_type) {
      for (var _key in this.disableRtCondition) {
        if (this.disableRtCondition[_key].client_id === client_id &&
          this.disableRtCondition[_key].permission_type === permission_type &&
          this.disableRtCondition[_key].is_duplicate !== '1') {
          this.disableRtCondition[_key].request_able = false
          console.error(this.disableRtCondition[_key])
        }
      }
    },
    fontPaymentDialog: function () {
      if (this.$globalVar.isYagiPrime) {
        this.selectFont()
        return
      }
      // デフォルトフォント値を取得
      const defaultFontValue = this.fontOptions[0].value
      // 汎用的なAPIを使用
      this.$yagiprimePaymentService.useFeatureWithDefault(
        this,
        'font-payment',
        this.formatData.selFont,
        defaultFontValue,
        {
          onSuccess: () => {
            // フォント購入成功時のコールバック
            this.handleFontPurchaseSuccess()
          },
          onCancel: () => {
            // キャンセル時にはデフォルトフォントに戻す
            this.formatData.selFont = defaultFontValue
            this.selectFont()
          }
        }
      )
    },
    // フォント購入成功時の処理
    handleFontPurchaseSuccess: function () {
      // UI更新のためのメッセージ表示
      if (this.$globalVar.isYagiPrime) {
        this.fontPaymented = true
        this.$message({
          message: 'ヤギプライム登録が完了しました。選択したフォントが適用されます。',
          type: 'success'
        })
      }

      this.selectFont()
    },

    // 既存のフォントリセット処理
    resetFontToDefault: function () {
      // デフォルトフォントに戻す処理
      if (!this.$firebase.isAuthenticated || !this.$globalVar.isYagiPrime) {
        this.formatData.selFont = this.fontOptions[0].value
        this.selectFont()
      }
    }
  },
  watch: {
    'cardId': function () {
      this.currentCardId = this.cardId
      if (this.currentCardIndex < 0) {
        this.goFirstCard()
      }
    },
    previewTabActive: function () {
      this.setPreviewScale()
    }
  },
  beforeMount: function () {
    if (Math.floor(Math.random() * 2) === 0) {
      this.randomNumber = 0
    } else {
      this.randomNumber = 1
    }
    this.loadCurrentFormat()
    if (this.currentFormat) {
      this.requiredBasicFields = this.currentFormat['requiredBasicFields']
    }
    if (this.cardId) {
      this.currentCardId = this.cardId
    }
    if (!this.$firebase.isAuthenticated) {
      if (this.currentCardId !== 'profile' && this.currentCardId !== '' && this.currentCardId !== 'letterprofile' && this.currentCardId !== 'output') {
        // console.error('open-tempdata-dialog：' + this.currentCardId)
        // this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
      }
    }
    window.addEventListener('beforeunload', this.preventNav)
    // ログインコンテキストをセットするイベントを登録
    this.$eventHub.$on('set-login-context', (context) => {
      this.loginContext = context
    })
  },
  beforeDestroy() {
    // Don't forget to clean up event listeners
    window.removeEventListener('beforeunload', this.preventNav)
    // ログインコンテキストをセットするイベントを解除
    this.$eventHub.$off('set-login-context')
  },
  created: function () {
    console.log('created')
    this.formatData.selFont = "font-family: 'Noto Sans JP', sans-serif;"
    this.selectFont()
    this.getFontpayment()
    if (this.currentCardId === 'confirm') {
      // this.setPreviewScale()
      this.showPreviewTest()
    }
    if (this.formatId === 'rirekisho_esf_challenged') {
      this.$globalVar.isShogai = true
    }

    // ヤギプライム課金サービスの初期化
    this.$yagiprimePaymentService.init(this)
  },
  mounted: function () {
    if (this.currentCardIndex < 0) {
      this.goFirstCard()
    }
    console.error('mounted:' + this.$firebase.isAuthenticated)
    this.$eventHub.$on('get_fontpayment', this.getFontpayment)
    this.$eventHub.$on('local-format-data-loaded', this.setPreviewHeight)
    this.$eventHub.$on('basic-data-changed', this.updateBasicData)

    this.$eventHub.$on('yagiprimefontpayment-dialog-closed', this.resetFontToDefault)

    this.$eventHub.$on('format-data-changed', this.updateFormatData)
    this.$eventHub.$on('format-otherdata-changed', this.updateFormatOtherData)
    this.$eventHub.$on('backup-loaded-' + RECENT_EDIT_SAVE_KEY, this.setRecentEdit)
    this.$eventHub.$on('save-complete-notify', this.saveNotify)
    this.$eventHub.$on('download-PDF', this.downloadPDF)
    this.$eventHub.$on('download-tap', this.goDownloadCard)
    this.$eventHub.$on('mail-PDF', this.mailPDF)
    this.$eventHub.$on('send-special-post', this.sendSpecialPost)
    this.$eventHub.$on('send-special-quickemail', this.sendQuickEmail)
    this.$eventHub.$on('send-special-newquickemail', this.sendNewQuickEmail)
    this.$eventHub.$on('go-card-to', this.goCardTo)
    this.$eventHub.$on('show-preview', this.showPreview)
    this.$eventHub.$on('select-font', this.selectFont)
    this.$eventHub.$on('show-preview-4conv', this.showPreview4Conv)
    this.$eventHub.$on('get_font_paymented', this.getFontPaymented)
    this.$eventHub.$on('send-yagish-intern', this.sendYagishIntern)
    this.$eventHub.$on('send-email-verification', this.sendEmailVerification)
    this.$eventHub.$on('fontpayment-flag-initialized', this.getFontpayment)
    this.$eventHub.$on('firebase-initialized', this.getQrcode)
    this.$eventHub.$on('send-recommend-request-shogai', this.sendRecommendRequestShogai)
    this.$eventHub.$on('regist-yagioffer-shogai', this.registYagiofferShogai)
    this.$eventHub.$on('display_rt_popup', this.displayPopup)
    this.$eventHub.$on('update_rt_condition', this.updateRtCondition)

    // 課金結果イベントリスナーを登録
    this.$yagiprimePaymentService.registerPaymentResultListener(this)

    if (this.preview === false) {
      this.closePreview()
    } else if (this.preview === true) {
      this.showPreview()
    }
    if (this.currentCardId === 'confirm') {
      // this.setPreviewScale()
      this.showPreviewTest()
    }
    const app = this
    this.$getItem(LAST_SAVE_DATE_SAVE_KEY, function (err, data) {
      if (err) {
        console.error(err)
        return
      }
      app.saveDate = data
      app.updateSaveNotifyMessage()
    })
    // set event listeners and timer
    window.addEventListener('popstate', this.hidePreviewDialog, false)
    window.addEventListener('resize', this.setPreviewScaleDebounce, false)
    this.saveNotifyMessageUpdateTimer = setInterval(this.updateSaveNotifyMessage, 5000)
  },
  destroyed: function () {
    // remove event listeners and timer
    this.$eventHub.$off('get_fontpayment', this.getFontpayment)
    this.$eventHub.$off('local-format-data-loaded', this.setPreviewHeight)
    this.$eventHub.$off('basic-data-changed', this.updateBasicData)
    this.$eventHub.$off('format-data-changed', this.updateFormatData)
    this.$eventHub.$off('format-otherdata-changed', this.updateFormatOtherData)
    this.$eventHub.$off('backup-loaded-' + RECENT_EDIT_SAVE_KEY, this.setRecentEdit)
    this.$eventHub.$off('save-complete-notify', this.saveNotify)
    this.$eventHub.$off('download-PDF', this.downloadPDF)
    this.$eventHub.$off('download-tap', this.goDownloadCard)
    this.$eventHub.$off('mail-PDF', this.mailPDF)
    this.$eventHub.$off('send-special-post', this.sendSpecialPost)
    this.$eventHub.$off('send-special-quickemail', this.sendQuickEmail)
    this.$eventHub.$off('send-special-newquickemail', this.sendNewQuickEmail)
    this.$eventHub.$off('go-card-to', this.goCardTo)
    this.$eventHub.$off('show-preview', this.showPreview)
    this.$eventHub.$off('get_font_paymented', this.getFontPaymented)
    this.$eventHub.$off('select-font', this.selectFont)
    this.$eventHub.$off('show-preview-4conv', this.showPreview4Conv)
    this.$eventHub.$off('send-yagish-intern', this.sendYagishIntern)
    this.$eventHub.$off('send-email-verification', this.sendEmailVerification)
    this.$eventHub.$off('fontpayment-flag-initialized', this.getFontpayment)
    this.$eventHub.$off('firebase-initialized', this.getQrcode)
    this.$eventHub.$off('send-recommend-request-shogai', this.sendRecommendRequestShogai)
    this.$eventHub.$off('regist-yagioffer-shogai', this.registYagiofferShogai)
    this.$eventHub.$off('display_rt_popup', this.displayPopup)
    this.$eventHub.$off('update_rt_condition', this.updateRtCondition)

    window.removeEventListener('popstate', this.hidePreviewDialog, false)
    window.removeEventListener('resize', this.setPreviewScaleDebounce, false)
    clearInterval(this.saveNotifyMessageUpdateTimer)

    this.$eventHub.$off('yagiprimefontpayment-dialog-closed', this.resetFontToDefault)

    // ヤギプライム課金サービスのクリーンアップ
    this.$yagiprimePaymentService.cleanup(this)
  }
}
</script>
